export const schema = {
    "models": {
        "AppConfig": {
            "name": "AppConfig",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "saveTimer": {
                    "name": "saveTimer",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "screenResponsiveWidth": {
                    "name": "screenResponsiveWidth",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "mobileResponsiveWidth": {
                    "name": "mobileResponsiveWidth",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "veryLargeScreenResponsiveWidth": {
                    "name": "veryLargeScreenResponsiveWidth",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "chartMaxHeight": {
                    "name": "chartMaxHeight",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "inactiveTimeout": {
                    "name": "inactiveTimeout",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "sideMenuWidth": {
                    "name": "sideMenuWidth",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "availableLanguages": {
                    "name": "availableLanguages",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "baseIntents": {
                    "name": "baseIntents",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "baseEntities": {
                    "name": "baseEntities",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "baseTopics": {
                    "name": "baseTopics",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "supportDomain": {
                    "name": "supportDomain",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "announcement": {
                    "name": "announcement",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lastAnnouncementInt": {
                    "name": "lastAnnouncementInt",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "AppConfigs",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "User": {
            "name": "User",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "owner": {
                    "name": "owner",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "username": {
                    "name": "username",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "user_email": {
                    "name": "user_email",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "user_email_verified": {
                    "name": "user_email_verified",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "user_phone_number": {
                    "name": "user_phone_number",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "timezone": {
                    "name": "timezone",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "language": {
                    "name": "language",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isSentenceSplitEnabled": {
                    "name": "isSentenceSplitEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isImplicitSelfEnabled": {
                    "name": "isImplicitSelfEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "replyLanguage": {
                    "name": "replyLanguage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "theme": {
                    "name": "theme",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "user_phone_number_verified": {
                    "name": "user_phone_number_verified",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "userInstructions": {
                    "name": "userInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "userMemories": {
                    "name": "userMemories",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "isOnboarded": {
                    "name": "isOnboarded",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "userHelperPreferences": {
                    "name": "userHelperPreferences",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sourceCode": {
                    "name": "sourceCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "referralCode": {
                    "name": "referralCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "referredBy": {
                    "name": "referredBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "couponCode": {
                    "name": "couponCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "image": {
                    "name": "image",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaces": {
                    "name": "workspaces",
                    "isArray": true,
                    "type": {
                        "model": "Workspace"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "userID"
                    }
                },
                "cognitoUsername": {
                    "name": "cognitoUsername",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "stripeCustomerId": {
                    "name": "stripeCustomerId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "subscribedToNewsletter": {
                    "name": "subscribedToNewsletter",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "newsletterConsentedAt": {
                    "name": "newsletterConsentedAt",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "newsletterConsentMethod": {
                    "name": "newsletterConsentMethod",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "newsletterConsentTermsVersion": {
                    "name": "newsletterConsentTermsVersion",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "newsletterPromptShown": {
                    "name": "newsletterPromptShown",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "newsletterSubscriptionStatus": {
                    "name": "newsletterSubscriptionStatus",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "newsletterUpdatedAt": {
                    "name": "newsletterUpdatedAt",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "isLead": {
                    "name": "isLead",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "stripePaymentIntentId": {
                    "name": "stripePaymentIntentId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "maximumNumberOfWorkspaces": {
                    "name": "maximumNumberOfWorkspaces",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "workspacesAccessLevel": {
                    "name": "workspacesAccessLevel",
                    "isArray": true,
                    "type": {
                        "model": "UserWorkspaceType"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "userID"
                    }
                },
                "lastViewedReleaseVersion": {
                    "name": "lastViewedReleaseVersion",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isMFAEnabled": {
                    "name": "isMFAEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "desktopAppInstalled": {
                    "name": "desktopAppInstalled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "lastAnnouncementViewedInt": {
                    "name": "lastAnnouncementViewedInt",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "expoPushTokens": {
                    "name": "expoPushTokens",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "enableExperimentalFeatures": {
                    "name": "enableExperimentalFeatures",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "Users",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "usersByOwner",
                        "queryField": "usersByOwner",
                        "fields": [
                            "owner"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "usersByEmail",
                        "queryField": "usersByEmail",
                        "fields": [
                            "user_email"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "usersByStripeCustomerID",
                        "queryField": "usersByStripeCustomerID",
                        "fields": [
                            "stripeCustomerId"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Workspace": {
            "name": "Workspace",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "owner": {
                    "name": "owner",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "title": {
                    "name": "title",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "visibility": {
                    "name": "visibility",
                    "isArray": false,
                    "type": {
                        "enum": "Visibility"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "userID": {
                    "name": "userID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "isMed": {
                    "name": "isMed",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "WorkspaceAiType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "usagePlanID": {
                    "name": "usagePlanID",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceTokenID": {
                    "name": "workspaceTokenID",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceToken": {
                    "name": "workspaceToken",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "subscriptionType": {
                    "name": "subscriptionType",
                    "isArray": false,
                    "type": {
                        "enum": "PlanType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "subscriptionId": {
                    "name": "subscriptionId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "subscriptionStatus": {
                    "name": "subscriptionStatus",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "enableExperimentalFeatures": {
                    "name": "enableExperimentalFeatures",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "utilityEndpoint": {
                    "name": "utilityEndpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "utilityUrl": {
                    "name": "utilityUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "utilityUrlStatus": {
                    "name": "utilityUrlStatus",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "utilityUrlType": {
                    "name": "utilityUrlType",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "utilityBaseModel": {
                    "name": "utilityBaseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "utilityProvider": {
                    "name": "utilityProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "codingEndpoint": {
                    "name": "codingEndpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "codingUrl": {
                    "name": "codingUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "codingUrlStatus": {
                    "name": "codingUrlStatus",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "codingUrlType": {
                    "name": "codingUrlType",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "codingBaseModel": {
                    "name": "codingBaseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "codingProvider": {
                    "name": "codingProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "generalPurposeEndpoint": {
                    "name": "generalPurposeEndpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "generalPurposeUrl": {
                    "name": "generalPurposeUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "generalPurposeUrlStatus": {
                    "name": "generalPurposeUrlStatus",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "generalPurposeUrlType": {
                    "name": "generalPurposeUrlType",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "generalPurposeBaseModel": {
                    "name": "generalPurposeBaseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "generalPurposeProvider": {
                    "name": "generalPurposeProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qaEnpoint": {
                    "name": "qaEnpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qaUrl": {
                    "name": "qaUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qaUrlStatus": {
                    "name": "qaUrlStatus",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "qaUrlType": {
                    "name": "qaUrlType",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "qaBaseModel": {
                    "name": "qaBaseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qaProvider": {
                    "name": "qaProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "cnEndpoint": {
                    "name": "cnEndpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "cnUrl": {
                    "name": "cnUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "cnUrlStatus": {
                    "name": "cnUrlStatus",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "cnUrlType": {
                    "name": "cnUrlType",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "cnBaseModel": {
                    "name": "cnBaseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "cnProvider": {
                    "name": "cnProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "gnEnpoint": {
                    "name": "gnEnpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "gnUrl": {
                    "name": "gnUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "gnUrlStatus": {
                    "name": "gnUrlStatus",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "gnUrlType": {
                    "name": "gnUrlType",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "gnBaseModel": {
                    "name": "gnBaseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "gnProvider": {
                    "name": "gnProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "nlpEnpoint": {
                    "name": "nlpEnpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "nlpUrl": {
                    "name": "nlpUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "nlpUrlStatus": {
                    "name": "nlpUrlStatus",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "nlpUrlType": {
                    "name": "nlpUrlType",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "nlpBaseModel": {
                    "name": "nlpBaseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "nlpProvider": {
                    "name": "nlpProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "embeddingEndpoint": {
                    "name": "embeddingEndpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "embeddingUrl": {
                    "name": "embeddingUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "embeddingUrlStatus": {
                    "name": "embeddingUrlStatus",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "embeddingUrlType": {
                    "name": "embeddingUrlType",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "embeddingBaseModel": {
                    "name": "embeddingBaseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "embeddingProvider": {
                    "name": "embeddingProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "chartingEndpoint": {
                    "name": "chartingEndpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "chartingUrl": {
                    "name": "chartingUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "chartingUrlStatus": {
                    "name": "chartingUrlStatus",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "chartingUrlType": {
                    "name": "chartingUrlType",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "chartingBaseModel": {
                    "name": "chartingBaseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "chartingProvider": {
                    "name": "chartingProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "imagingEndpoint": {
                    "name": "imagingEndpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "imagingUrl": {
                    "name": "imagingUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "imagingUrlStatus": {
                    "name": "imagingUrlStatus",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "imagingUrlType": {
                    "name": "imagingUrlType",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "imagingBaseModel": {
                    "name": "imagingBaseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "imagingProvider": {
                    "name": "imagingProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "reasoningEndpoint": {
                    "name": "reasoningEndpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "reasoningUrl": {
                    "name": "reasoningUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "reasoningUrlStatus": {
                    "name": "reasoningUrlStatus",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "reasoningUrlType": {
                    "name": "reasoningUrlType",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "reasoningBaseModel": {
                    "name": "reasoningBaseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "reasoningProvider": {
                    "name": "reasoningProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "defaultChatVisibility": {
                    "name": "defaultChatVisibility",
                    "isArray": false,
                    "type": {
                        "enum": "ChatVisibility"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "billingStatus": {
                    "name": "billingStatus",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lastBillingDate": {
                    "name": "lastBillingDate",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lastConsumptionNotificationDate": {
                    "name": "lastConsumptionNotificationDate",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "activeUntil": {
                    "name": "activeUntil",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "paymentFailed": {
                    "name": "paymentFailed",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "bulkImportAllowed": {
                    "name": "bulkImportAllowed",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "lastPaymentAttempt": {
                    "name": "lastPaymentAttempt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "targetSubscriptionType": {
                    "name": "targetSubscriptionType",
                    "isArray": false,
                    "type": {
                        "enum": "PlanType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "lastChangeSubscriptionDate": {
                    "name": "lastChangeSubscriptionDate",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "maxUsers": {
                    "name": "maxUsers",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "minUsers": {
                    "name": "minUsers",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "contractStartDate": {
                    "name": "contractStartDate",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "xeroId": {
                    "name": "xeroId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "xeroContactId": {
                    "name": "xeroContactId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "xeroInvoiceId": {
                    "name": "xeroInvoiceId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lastXeroBillingDate": {
                    "name": "lastXeroBillingDate",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "billingProvider": {
                    "name": "billingProvider",
                    "isArray": false,
                    "type": {
                        "enum": "BillingProvider"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "supportHours": {
                    "name": "supportHours",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "supportHoursUsed": {
                    "name": "supportHoursUsed",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "reservedComputeAllocation": {
                    "name": "reservedComputeAllocation",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "baseModel": {
                    "name": "baseModel",
                    "isArray": false,
                    "type": {
                        "enum": "BaseModelType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "domain": {
                    "name": "domain",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "trainingConfig": {
                    "name": "trainingConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "TrainingConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "parsingConfig": {
                    "name": "parsingConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "ParsingConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "notificationConfig": {
                    "name": "notificationConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "NotificationConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "embeddingConfig": {
                    "name": "embeddingConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "EmbeddingConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "customGenerationConfig": {
                    "name": "customGenerationConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "CustomGenerationConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "customImageRecognitionModel": {
                    "name": "customImageRecognitionModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customVectorDB": {
                    "name": "customVectorDB",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceAgents": {
                    "name": "workspaceAgents",
                    "isArray": true,
                    "type": {
                        "model": "Agent"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "workspaceCustomPrompts": {
                    "name": "workspaceCustomPrompts",
                    "isArray": true,
                    "type": {
                        "model": "CustomPrompt"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "customQaConfig": {
                    "name": "customQaConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "CustomQaConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "aiConsumption": {
                    "name": "aiConsumption",
                    "isArray": false,
                    "type": {
                        "nonModel": "AiWorkspaceConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "aggregatedConsumption": {
                    "name": "aggregatedConsumption",
                    "isArray": false,
                    "type": {
                        "nonModel": "AiWorkspaceConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "customUoiPrice": {
                    "name": "customUoiPrice",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "disabled": {
                    "name": "disabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "subscriptionPricingPlan": {
                    "name": "subscriptionPricingPlan",
                    "isArray": true,
                    "type": {
                        "model": "SubscriptionPricingPlan"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "type"
                    }
                },
                "folders": {
                    "name": "folders",
                    "isArray": true,
                    "type": {
                        "model": "Folders"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "trainingLogs": {
                    "name": "trainingLogs",
                    "isArray": true,
                    "type": {
                        "model": "TrainingLog"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "entities": {
                    "name": "entities",
                    "isArray": true,
                    "type": {
                        "model": "EntityAI"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "appLogs": {
                    "name": "appLogs",
                    "isArray": true,
                    "type": {
                        "model": "AppLog"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "batchJobs": {
                    "name": "batchJobs",
                    "isArray": true,
                    "type": {
                        "model": "BatchJobLog"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "dictionaryItems": {
                    "name": "dictionaryItems",
                    "isArray": true,
                    "type": {
                        "model": "DictionaryItem"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "requestsLogs": {
                    "name": "requestsLogs",
                    "isArray": true,
                    "type": {
                        "model": "RequestLog"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "communicationServices": {
                    "name": "communicationServices",
                    "isArray": true,
                    "type": {
                        "model": "CommunicationService"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "sites": {
                    "name": "sites",
                    "isArray": true,
                    "type": {
                        "model": "Site"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "cronJobs": {
                    "name": "cronJobs",
                    "isArray": true,
                    "type": {
                        "model": "CronJob"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "customExecutionEnvironments": {
                    "name": "customExecutionEnvironments",
                    "isArray": true,
                    "type": {
                        "model": "CustomExecutionEnvironment"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "users": {
                    "name": "users",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "userCognitoIds": {
                    "name": "userCognitoIds",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "usersAccessLevel": {
                    "name": "usersAccessLevel",
                    "isArray": true,
                    "type": {
                        "model": "UserWorkspaceType"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "workspaceID"
                    }
                },
                "workspaceCreationDate": {
                    "name": "workspaceCreationDate",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceModelReady": {
                    "name": "workspaceModelReady",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "enableDeleteFunctionInAgents": {
                    "name": "enableDeleteFunctionInAgents",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "enableUpdateFunctionInAgents": {
                    "name": "enableUpdateFunctionInAgents",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "enableCustomFunctionInAgents": {
                    "name": "enableCustomFunctionInAgents",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "defaultChatAgent": {
                    "name": "defaultChatAgent",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "defaultBusinessAnalystAgent": {
                    "name": "defaultBusinessAnalystAgent",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "defaultContentCreatorAgent": {
                    "name": "defaultContentCreatorAgent",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "isSentimentReviewerEnabled": {
                    "name": "isSentimentReviewerEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isExtendedContentCreatorEnabled": {
                    "name": "isExtendedContentCreatorEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isExtendedBusinessAnalystReportEnabled": {
                    "name": "isExtendedBusinessAnalystReportEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "customIndexedDBendpoint": {
                    "name": "customIndexedDBendpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "federationMetadataUrl": {
                    "name": "federationMetadataUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "federationMetadataUrlStatus": {
                    "name": "federationMetadataUrlStatus",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "federationMetadataUrlType": {
                    "name": "federationMetadataUrlType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "ssoType": {
                    "name": "ssoType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "ssoDomain": {
                    "name": "ssoDomain",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "ssoProviderName": {
                    "name": "ssoProviderName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isMultiLanguageEnabled": {
                    "name": "isMultiLanguageEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "customChartingConfig": {
                    "name": "customChartingConfig",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "twilioConfig": {
                    "name": "twilioConfig",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "emailConfig": {
                    "name": "emailConfig",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "isMFAEnabled": {
                    "name": "isMFAEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "advancedVectorisation": {
                    "name": "advancedVectorisation",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "advancedCompute": {
                    "name": "advancedCompute",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "enableAutoInvite": {
                    "name": "enableAutoInvite",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "autoInviteDomain": {
                    "name": "autoInviteDomain",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "autoInviteUserRole": {
                    "name": "autoInviteUserRole",
                    "isArray": false,
                    "type": {
                        "enum": "UserType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "customMaxPowerUsers": {
                    "name": "customMaxPowerUsers",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "customUoiBudget": {
                    "name": "customUoiBudget",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "requestsPer30MinutesFactor": {
                    "name": "requestsPer30MinutesFactor",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "webhookUrl": {
                    "name": "webhookUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "webhookAuthorisationType": {
                    "name": "webhookAuthorisationType",
                    "isArray": false,
                    "type": {
                        "enum": "AuthorisationType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "webhookAuthorisationID": {
                    "name": "webhookAuthorisationID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "logo": {
                    "name": "logo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "enforceRegionalModels": {
                    "name": "enforceRegionalModels",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "blockedModels": {
                    "name": "blockedModels",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "billingPeriodStart": {
                    "name": "billingPeriodStart",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "billingPeriodEnd": {
                    "name": "billingPeriodEnd",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "parentWorkspaceID": {
                    "name": "parentWorkspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "Workspaces",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "UserWorkspaces",
                        "queryField": "UserWorkspaces",
                        "fields": [
                            "userID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "workspacesByToken",
                        "queryField": "workspacesByToken",
                        "fields": [
                            "workspaceToken"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "workspacesBySSOdomain",
                        "queryField": "workspacesBySSOdomain",
                        "fields": [
                            "ssoDomain"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "workspacesByInviteDomain",
                        "queryField": "workspacesByInviteDomain",
                        "fields": [
                            "autoInviteDomain"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspacesByParent",
                        "queryField": "workspacesByParent",
                        "fields": [
                            "parentWorkspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "UserPolicy": {
            "name": "UserPolicy",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "inheritFrom": {
                    "name": "inheritFrom",
                    "isArray": false,
                    "type": {
                        "enum": "UserType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "properties": {
                    "name": "properties",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "allowedDocs": {
                    "name": "allowedDocs",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "allowedModels": {
                    "name": "allowedModels",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "allowedAgents": {
                    "name": "allowedAgents",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "creationTime": {
                    "name": "creationTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "UserPolicies",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "policiesToWorkspaceMapping",
                        "queryField": "policiesToWorkspaceMapping",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "UserWorkspaceType": {
            "name": "UserWorkspaceType",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "userID": {
                    "name": "userID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "userType": {
                    "name": "userType",
                    "isArray": false,
                    "type": {
                        "enum": "UserType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "policyID": {
                    "name": "policyID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "favoriteAgents": {
                    "name": "favoriteAgents",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "recentLocalFolders": {
                    "name": "recentLocalFolders",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "recentFiles": {
                    "name": "recentFiles",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "UserWorkspaceTypes",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "userToWorkspaceMapping",
                        "queryField": "userToWorkspaceMapping",
                        "fields": [
                            "workspaceID",
                            "userID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "ByUser",
                        "queryField": "workspacesByUser",
                        "fields": [
                            "userID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Agent": {
            "name": "Agent",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "label": {
                    "name": "label",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "interpolationString": {
                    "name": "interpolationString",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "emoji": {
                    "name": "emoji",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "color": {
                    "name": "color",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "darkColor": {
                    "name": "darkColor",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "icon": {
                    "name": "icon",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "largeLogo": {
                    "name": "largeLogo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "icoUrl": {
                    "name": "icoUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "logoBackground": {
                    "name": "logoBackground",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "darkLogoBackground": {
                    "name": "darkLogoBackground",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "messageOnLaunch": {
                    "name": "messageOnLaunch",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "messagesOnLaunch": {
                    "name": "messagesOnLaunch",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "rotateMessagesOnLaunch": {
                    "name": "rotateMessagesOnLaunch",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "rotateMessagesOnLaunchInterval": {
                    "name": "rotateMessagesOnLaunchInterval",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "placeholderMessageOnLoading": {
                    "name": "placeholderMessageOnLoading",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "dynamicPlaceholderMessageOnLoading": {
                    "name": "dynamicPlaceholderMessageOnLoading",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "customGreetingInstructions": {
                    "name": "customGreetingInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customConclusionInstructions": {
                    "name": "customConclusionInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customChartingInstructions": {
                    "name": "customChartingInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customSummarisationInstructions": {
                    "name": "customSummarisationInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customImagesInstructions": {
                    "name": "customImagesInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customToolingInstructions": {
                    "name": "customToolingInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "placeholderInputMessage": {
                    "name": "placeholderInputMessage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "openByDefault": {
                    "name": "openByDefault",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "agenticCodingModel": {
                    "name": "agenticCodingModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "disclaimer": {
                    "name": "disclaimer",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "showDocumentsReferences": {
                    "name": "showDocumentsReferences",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isDefault": {
                    "name": "isDefault",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasMemory": {
                    "name": "hasMemory",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasImages": {
                    "name": "hasImages",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "promptTopKeywords": {
                    "name": "promptTopKeywords",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "keyWordsForKnowledgeBase": {
                    "name": "keyWordsForKnowledgeBase",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasTopicsContext": {
                    "name": "hasTopicsContext",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasFunctions": {
                    "name": "hasFunctions",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "advancedLanguageDetection": {
                    "name": "advancedLanguageDetection",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowedTopics": {
                    "name": "allowedTopics",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "staticDocs": {
                    "name": "staticDocs",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "defaultAnswer": {
                    "name": "defaultAnswer",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "noKnowledgeDefaultAnswer": {
                    "name": "noKnowledgeDefaultAnswer",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "quickQuestions": {
                    "name": "quickQuestions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "recencyImportance": {
                    "name": "recencyImportance",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "maxRecencyIncrease": {
                    "name": "maxRecencyIncrease",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "recencyTopKIncreaseFactor": {
                    "name": "recencyTopKIncreaseFactor",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "stopSequence": {
                    "name": "stopSequence",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "examples": {
                    "name": "examples",
                    "isArray": true,
                    "type": {
                        "nonModel": "QA"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "enhancementPassage": {
                    "name": "enhancementPassage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "inhibitionPassage": {
                    "name": "inhibitionPassage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "pertinencePassage": {
                    "name": "pertinencePassage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "goals": {
                    "name": "goals",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "qaUrl": {
                    "name": "qaUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "topK": {
                    "name": "topK",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "mode": {
                    "name": "mode",
                    "isArray": false,
                    "type": {
                        "enum": "ChatMode"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "showCodeInExecution": {
                    "name": "showCodeInExecution",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hideReasoning": {
                    "name": "hideReasoning",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "charting": {
                    "name": "charting",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "summarisation": {
                    "name": "summarisation",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "compressor": {
                    "name": "compressor",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "docTopK": {
                    "name": "docTopK",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "minRetrievalScore": {
                    "name": "minRetrievalScore",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "timeSignificance": {
                    "name": "timeSignificance",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "hasModeration": {
                    "name": "hasModeration",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "customModerations": {
                    "name": "customModerations",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "moderationMessage": {
                    "name": "moderationMessage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "languageDetectionConfidence": {
                    "name": "languageDetectionConfidence",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "maxHistory": {
                    "name": "maxHistory",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxTokens": {
                    "name": "maxTokens",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "topicEnhancer": {
                    "name": "topicEnhancer",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "maxTopics": {
                    "name": "maxTopics",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "blender": {
                    "name": "blender",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "temperature": {
                    "name": "temperature",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "seed": {
                    "name": "seed",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "version": {
                    "name": "version",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "subject": {
                    "name": "subject",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "agentFunctions": {
                    "name": "agentFunctions",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "isGlobal": {
                    "name": "isGlobal",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "promptBuffering": {
                    "name": "promptBuffering",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "functionContext": {
                    "name": "functionContext",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "plainTextOutput": {
                    "name": "plainTextOutput",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "chainOfThoughts": {
                    "name": "chainOfThoughts",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "treeOfThoughts": {
                    "name": "treeOfThoughts",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "extendedOutput": {
                    "name": "extendedOutput",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "agentType": {
                    "name": "agentType",
                    "isArray": false,
                    "type": {
                        "enum": "AgentType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "agentsPool": {
                    "name": "agentsPool",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "mcps": {
                    "name": "mcps",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "maxPlanningSteps": {
                    "name": "maxPlanningSteps",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxBrowserSteps": {
                    "name": "maxBrowserSteps",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "virtualDesktopInstructions": {
                    "name": "virtualDesktopInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "planningInstructions": {
                    "name": "planningInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "plannerExecutionAttempts": {
                    "name": "plannerExecutionAttempts",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "plannerRequiresApprovalForPlanExecution": {
                    "name": "plannerRequiresApprovalForPlanExecution",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "plannerEmailOnApprovalRequest": {
                    "name": "plannerEmailOnApprovalRequest",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "plannerEmailOnFailedPlan": {
                    "name": "plannerEmailOnFailedPlan",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "plannerEmailOnCompletedPlan": {
                    "name": "plannerEmailOnCompletedPlan",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "plannerAutoAgentSpawn": {
                    "name": "plannerAutoAgentSpawn",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "plannerRetainsSpawnedAgents": {
                    "name": "plannerRetainsSpawnedAgents",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "plannerPromptsAgentsProgrammatically": {
                    "name": "plannerPromptsAgentsProgrammatically",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "plannerDeepThinking": {
                    "name": "plannerDeepThinking",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowReplanning": {
                    "name": "allowReplanning",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "plannerProceedsWhenImprovementsRequired": {
                    "name": "plannerProceedsWhenImprovementsRequired",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "plannerApproverEmails": {
                    "name": "plannerApproverEmails",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "reviewInstructions": {
                    "name": "reviewInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "showReferencesToInternalDocs": {
                    "name": "showReferencesToInternalDocs",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "showCitations": {
                    "name": "showCitations",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "forceJsonOutput": {
                    "name": "forceJsonOutput",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "agenticRAG": {
                    "name": "agenticRAG",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "preventWidgetUsage": {
                    "name": "preventWidgetUsage",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowFeedback": {
                    "name": "allowFeedback",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "generateExtendedReport": {
                    "name": "generateExtendedReport",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "showTimeForResponse": {
                    "name": "showTimeForResponse",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "showDetectedLanguage": {
                    "name": "showDetectedLanguage",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "showRoutedModel": {
                    "name": "showRoutedModel",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isMultiLanguageEnabled": {
                    "name": "isMultiLanguageEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasMath": {
                    "name": "hasMath",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasCode": {
                    "name": "hasCode",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasComputer": {
                    "name": "hasComputer",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasNER": {
                    "name": "hasNER",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "restrictedAccess": {
                    "name": "restrictedAccess",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "restrictedAccessUsers": {
                    "name": "restrictedAccessUsers",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "splashTitle": {
                    "name": "splashTitle",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "showSplashWhenEmpty": {
                    "name": "showSplashWhenEmpty",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "llmEndpoint": {
                    "name": "llmEndpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "llmUrl": {
                    "name": "llmUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "llmUrlStatus": {
                    "name": "llmUrlStatus",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "llmUrlType": {
                    "name": "llmUrlType",
                    "isArray": false,
                    "type": {
                        "enum": "QaUrlType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "llmBaseModel": {
                    "name": "llmBaseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "llmProvider": {
                    "name": "llmProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "llmTopK": {
                    "name": "llmTopK",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "llmSeed": {
                    "name": "llmSeed",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "forcedTheme": {
                    "name": "forcedTheme",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "adverserialProvider": {
                    "name": "adverserialProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "adverserialModel": {
                    "name": "adverserialModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "functionCallingProvider": {
                    "name": "functionCallingProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "functionCallingModel": {
                    "name": "functionCallingModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "visionProvider": {
                    "name": "visionProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "visionModel": {
                    "name": "visionModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "browserProvider": {
                    "name": "browserProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "browserModel": {
                    "name": "browserModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "videoGenerationProvider": {
                    "name": "videoGenerationProvider",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "videoGenerationModel": {
                    "name": "videoGenerationModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "showAgentName": {
                    "name": "showAgentName",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowImagesUpload": {
                    "name": "allowImagesUpload",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowVideosUpload": {
                    "name": "allowVideosUpload",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowAudiosUpload": {
                    "name": "allowAudiosUpload",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowDocsUpload": {
                    "name": "allowDocsUpload",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowImagesGeneration": {
                    "name": "allowImagesGeneration",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "baseImageGenerationModel": {
                    "name": "baseImageGenerationModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "maxImagesGenerated": {
                    "name": "maxImagesGenerated",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "advancedImageGeneration": {
                    "name": "advancedImageGeneration",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowVideosGeneration": {
                    "name": "allowVideosGeneration",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowAudiosGeneration": {
                    "name": "allowAudiosGeneration",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowIntrospection": {
                    "name": "allowIntrospection",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "voiceFileKey": {
                    "name": "voiceFileKey",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "audiosGenerationTtsModel": {
                    "name": "audiosGenerationTtsModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "audiosGenerationVoiceName": {
                    "name": "audiosGenerationVoiceName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "audiosGenerationSpeechMode": {
                    "name": "audiosGenerationSpeechMode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "allowInternetSearch": {
                    "name": "allowInternetSearch",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "bannedDomains": {
                    "name": "bannedDomains",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "maxUrlsForInternetSearch": {
                    "name": "maxUrlsForInternetSearch",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "allowDeepInternetSearch": {
                    "name": "allowDeepInternetSearch",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "internetSearchModes": {
                    "name": "internetSearchModes",
                    "isArray": true,
                    "type": {
                        "enum": "InternetSearchMode"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "internetSearchLocation": {
                    "name": "internetSearchLocation",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "autoVoiceMode": {
                    "name": "autoVoiceMode",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "voiceSensitivity": {
                    "name": "voiceSensitivity",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "keywordsWeightInRetrieval": {
                    "name": "keywordsWeightInRetrieval",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "customCodeExecutionEnvironments": {
                    "name": "customCodeExecutionEnvironments",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "phoneNumberAsSender": {
                    "name": "phoneNumberAsSender",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "whatsappNumberAsSender": {
                    "name": "whatsappNumberAsSender",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "emailAsSender": {
                    "name": "emailAsSender",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "communicationServices": {
                    "name": "communicationServices",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "channelCallbackDelay": {
                    "name": "channelCallbackDelay",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "ephemeralAgent": {
                    "name": "ephemeralAgent",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "parentAgentID": {
                    "name": "parentAgentID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "parentChatID": {
                    "name": "parentChatID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "minimumSubscriptionType": {
                    "name": "minimumSubscriptionType",
                    "isArray": false,
                    "type": {
                        "enum": "PlanType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "clonedAgentID": {
                    "name": "clonedAgentID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "clonedAgentIDIcon": {
                    "name": "clonedAgentIDIcon",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "hasContentCreation": {
                    "name": "hasContentCreation",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasEntityExtraction": {
                    "name": "hasEntityExtraction",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "department": {
                    "name": "department",
                    "isArray": false,
                    "type": {
                        "enum": "Department"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "allowEmailToAgent": {
                    "name": "allowEmailToAgent",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowedEmails": {
                    "name": "allowedEmails",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "agentHiringTemplate": {
                    "name": "agentHiringTemplate",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "agentDesktopVM": {
                    "name": "agentDesktopVM",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "agentDesktopPortRange": {
                    "name": "agentDesktopPortRange",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "agentDesktopCredentials": {
                    "name": "agentDesktopCredentials",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "agentDesktopBrowser": {
                    "name": "agentDesktopBrowser",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allow3dModelGeneration": {
                    "name": "allow3dModelGeneration",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "agentLongTermMemory": {
                    "name": "agentLongTermMemory",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isLongTermMemoryEnabled": {
                    "name": "isLongTermMemoryEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowExternalAPI": {
                    "name": "allowExternalAPI",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "forceNewThreadOnProgrammaticRequest": {
                    "name": "forceNewThreadOnProgrammaticRequest",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "dynamicModelSelectionInstructions": {
                    "name": "dynamicModelSelectionInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "contextRelevancyRatio": {
                    "name": "contextRelevancyRatio",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "reasoningBudget": {
                    "name": "reasoningBudget",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "reasoningMode": {
                    "name": "reasoningMode",
                    "isArray": false,
                    "type": {
                        "enum": "ReasoningMode"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "reasoningEffort": {
                    "name": "reasoningEffort",
                    "isArray": false,
                    "type": {
                        "enum": "ReasoningEffort"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "fnReasoningEffort": {
                    "name": "fnReasoningEffort",
                    "isArray": false,
                    "type": {
                        "enum": "ReasoningEffort"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "agentFnParams": {
                    "name": "agentFnParams",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "canvasEnabled": {
                    "name": "canvasEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "advancedCompute": {
                    "name": "advancedCompute",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "reRank": {
                    "name": "reRank",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "minDeepSearchPagesPercentage": {
                    "name": "minDeepSearchPagesPercentage",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "voiceName": {
                    "name": "voiceName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "vadThresholds": {
                    "name": "vadThresholds",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "analyticsInstructions": {
                    "name": "analyticsInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "analyticsCustomFields": {
                    "name": "analyticsCustomFields",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "alertIDs": {
                    "name": "alertIDs",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "ragInstructions": {
                    "name": "ragInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "allowAskQuestion": {
                    "name": "allowAskQuestion",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "ragSearchStrategy": {
                    "name": "ragSearchStrategy",
                    "isArray": false,
                    "type": {
                        "enum": "SearchStrategy"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "minChunksBeforeCompleteness": {
                    "name": "minChunksBeforeCompleteness",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "ragCompletenessThreshold": {
                    "name": "ragCompletenessThreshold",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "voiceInstructions": {
                    "name": "voiceInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sttModel": {
                    "name": "sttModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "llmVoiceModel": {
                    "name": "llmVoiceModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "ttsModel": {
                    "name": "ttsModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "defaultVoiceLanguage": {
                    "name": "defaultVoiceLanguage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "voiceMinSilenceDuration": {
                    "name": "voiceMinSilenceDuration",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "voiceMinEndpointingDelay": {
                    "name": "voiceMinEndpointingDelay",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "voiceMinInterruptionDuration": {
                    "name": "voiceMinInterruptionDuration",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "enableVoiceIntermissions": {
                    "name": "enableVoiceIntermissions",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "voiceBackgroundNoise": {
                    "name": "voiceBackgroundNoise",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sipPhoneNumber": {
                    "name": "sipPhoneNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sipDispatchRuleId": {
                    "name": "sipDispatchRuleId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "enableInboundSip": {
                    "name": "enableInboundSip",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "enableOutboundSip": {
                    "name": "enableOutboundSip",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "enableJsonOutput": {
                    "name": "enableJsonOutput",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "jsonOutputStructure": {
                    "name": "jsonOutputStructure",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "predictedPlanJson": {
                    "name": "predictedPlanJson",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "useInterleavedReasoning": {
                    "name": "useInterleavedReasoning",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "interleavedPreset": {
                    "name": "interleavedPreset",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "maxTotalToolCalls": {
                    "name": "maxTotalToolCalls",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxConsecutiveSameTool": {
                    "name": "maxConsecutiveSameTool",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxConsecutiveFailures": {
                    "name": "maxConsecutiveFailures",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "regionalEndpoint": {
                    "name": "regionalEndpoint",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "agentVersion": {
                    "name": "agentVersion",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "agentCategoryType": {
                    "name": "agentCategoryType",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "maxSessionUoI": {
                    "name": "maxSessionUoI",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxSessionTurns": {
                    "name": "maxSessionTurns",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxSessionMessage": {
                    "name": "maxSessionMessage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "showWidgetControls": {
                    "name": "showWidgetControls",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowIpRotationViaProxy": {
                    "name": "allowIpRotationViaProxy",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "showToolCallsDetailsInWidget": {
                    "name": "showToolCallsDetailsInWidget",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowProxyScraping": {
                    "name": "allowProxyScraping",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "Agents",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceAgents",
                        "queryField": "agentsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "emailAsSender",
                        "queryField": "emailAsSender",
                        "fields": [
                            "emailAsSender"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "GetAgentByPhoneNumber",
                        "queryField": "GetAgentByPhoneNumber",
                        "fields": [
                            "sipPhoneNumber"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "AgentFunction": {
            "name": "AgentFunction",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "parameters": {
                    "name": "parameters",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "model": {
                    "name": "model",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "url": {
                    "name": "url",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "requestType": {
                    "name": "requestType",
                    "isArray": false,
                    "type": {
                        "enum": "FunctionRequestType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "authorisationType": {
                    "name": "authorisationType",
                    "isArray": false,
                    "type": {
                        "enum": "AuthorisationType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "dependsOnBeforeExecution": {
                    "name": "dependsOnBeforeExecution",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "dependsOnAfterExecution": {
                    "name": "dependsOnAfterExecution",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "authorisationKey": {
                    "name": "authorisationKey",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "authorisationID": {
                    "name": "authorisationID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "paramsAsPath": {
                    "name": "paramsAsPath",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "scope": {
                    "name": "scope",
                    "isArray": false,
                    "type": {
                        "enum": "FunctionScope"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "jsonPathExtractor": {
                    "name": "jsonPathExtractor",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "headers": {
                    "name": "headers",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "staticArgs": {
                    "name": "staticArgs",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "customExecutionCode": {
                    "name": "customExecutionCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isMCPServer": {
                    "name": "isMCPServer",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isCallbackFn": {
                    "name": "isCallbackFn",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isDatabaseScript": {
                    "name": "isDatabaseScript",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isHtmlFn": {
                    "name": "isHtmlFn",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isChatFn": {
                    "name": "isChatFn",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isHandOffFn": {
                    "name": "isHandOffFn",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isCodeTemplate": {
                    "name": "isCodeTemplate",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isAgentSkill": {
                    "name": "isAgentSkill",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "codeExecutionEnvironmentID": {
                    "name": "codeExecutionEnvironmentID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "onFnCall": {
                    "name": "onFnCall",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "handOffAgent": {
                    "name": "handOffAgent",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "handOffToOriginalAgentOnCompletion": {
                    "name": "handOffToOriginalAgentOnCompletion",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "handOffToOriginalAgentOnFailure": {
                    "name": "handOffToOriginalAgentOnFailure",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "handOffAgentOnCompletion": {
                    "name": "handOffAgentOnCompletion",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "handOffAgentOnFailure": {
                    "name": "handOffAgentOnFailure",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "agentSkillScript": {
                    "name": "agentSkillScript",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "chatScript": {
                    "name": "chatScript",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "chatAction": {
                    "name": "chatAction",
                    "isArray": false,
                    "type": {
                        "enum": "AgentFunctionChatAction"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "htmlUrl": {
                    "name": "htmlUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "htmlScript": {
                    "name": "htmlScript",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isHtmlRedirectFn": {
                    "name": "isHtmlRedirectFn",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "htmlFormOnSuccessfulSubmitMessage": {
                    "name": "htmlFormOnSuccessfulSubmitMessage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "htmlFormOnFailedSubmitMessage": {
                    "name": "htmlFormOnFailedSubmitMessage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "dbSchemaMetadata": {
                    "name": "dbSchemaMetadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "preExecutionScript": {
                    "name": "preExecutionScript",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "postExecutionScript": {
                    "name": "postExecutionScript",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "dbScript": {
                    "name": "dbScript",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "dbConnectionID": {
                    "name": "dbConnectionID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "preExecutionFnID": {
                    "name": "preExecutionFnID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "preExecutionMapping": {
                    "name": "preExecutionMapping",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "OAuthConnectionID": {
                    "name": "OAuthConnectionID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "handedOffToHumanOnCall": {
                    "name": "handedOffToHumanOnCall",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "graphqlQuery": {
                    "name": "graphqlQuery",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "graphqlMutation": {
                    "name": "graphqlMutation",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "graphqlOperationName": {
                    "name": "graphqlOperationName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "usersToHandOffTo": {
                    "name": "usersToHandOffTo",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isGlobal": {
                    "name": "isGlobal",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "functionVersion": {
                    "name": "functionVersion",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "functionType": {
                    "name": "functionType",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "AgentFunctions",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "AgentFunctionsByWorkspace",
                        "queryField": "functionsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Authorisation": {
            "name": "Authorisation",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "tokenSecret": {
                    "name": "tokenSecret",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "scope": {
                    "name": "scope",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "grantType": {
                    "name": "grantType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "clientId": {
                    "name": "clientId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "clientSecret": {
                    "name": "clientSecret",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "authorizationBaseUrl": {
                    "name": "authorizationBaseUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "staticArgs": {
                    "name": "staticArgs",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "tokenBaseUrl": {
                    "name": "tokenBaseUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "AuthorisationType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "Authorisations",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "AuthorisationsByWorkspace",
                        "queryField": "authorisationsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Hosting": {
            "name": "Hosting",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "tokenSecret": {
                    "name": "tokenSecret",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "endpoint": {
                    "name": "endpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "modelName": {
                    "name": "modelName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "baseModel": {
                    "name": "baseModel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customModel": {
                    "name": "customModel",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "apiVersion": {
                    "name": "apiVersion",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "HostingType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "Hostings",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "HostingsByWorkspace",
                        "queryField": "HostingsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "MCP": {
            "name": "MCP",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "version": {
                    "name": "version",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "tokenSecret": {
                    "name": "tokenSecret",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "endpoint": {
                    "name": "endpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "toolsAvailable": {
                    "name": "toolsAvailable",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "resourcesAvailable": {
                    "name": "resourcesAvailable",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "promptsAvailable": {
                    "name": "promptsAvailable",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isGlobal": {
                    "name": "isGlobal",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "MCPS",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "MCPByWorkspace",
                        "queryField": "MCPByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DatabaseConnection": {
            "name": "DatabaseConnection",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "host": {
                    "name": "host",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "port": {
                    "name": "port",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "username": {
                    "name": "username",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "passwordSecret": {
                    "name": "passwordSecret",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "database": {
                    "name": "database",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "schema": {
                    "name": "schema",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "ssl": {
                    "name": "ssl",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "ssh": {
                    "name": "ssh",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "sshHost": {
                    "name": "sshHost",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sshPort": {
                    "name": "sshPort",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sshUsername": {
                    "name": "sshUsername",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sshPasswordSecret": {
                    "name": "sshPasswordSecret",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "DatabaseConnections",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "DatabaseConnectionsByWorkspace",
                        "queryField": "connectionsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "UserNotification": {
            "name": "UserNotification",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "title": {
                    "name": "title",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "userID": {
                    "name": "userID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "UserNotifications",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "notificationsByUsers",
                        "queryField": "notificationsByUsers",
                        "fields": [
                            "userID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "notificationsByWorkspace",
                        "queryField": "notificationsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Alert": {
            "name": "Alert",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "triggerType": {
                    "name": "triggerType",
                    "isArray": false,
                    "type": {
                        "enum": "AlertTriggerType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "conditions": {
                    "name": "conditions",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": true,
                    "attributes": []
                },
                "severity": {
                    "name": "severity",
                    "isArray": false,
                    "type": {
                        "enum": "AlertSeverity"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "isActive": {
                    "name": "isActive",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "cooldownMinutes": {
                    "name": "cooldownMinutes",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "lastTriggeredAt": {
                    "name": "lastTriggeredAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "agentID": {
                    "name": "agentID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "recipients": {
                    "name": "recipients",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "recipientEmails": {
                    "name": "recipientEmails",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "notifyEmail": {
                    "name": "notifyEmail",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "notifyPush": {
                    "name": "notifyPush",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "notifyInApp": {
                    "name": "notifyInApp",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "notifyWebhook": {
                    "name": "notifyWebhook",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "Alerts",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "AlertsByAgent",
                        "queryField": "alertsByAgent",
                        "fields": [
                            "agentID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "AlertsByWorkspace",
                        "queryField": "alertsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "VirtualMachine": {
            "name": "VirtualMachine",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "ip": {
                    "name": "ip",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "port": {
                    "name": "port",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "VirtualMachines",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceVirtualMachines",
                        "queryField": "virtualMachinesByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "CustomExecutionEnvironment": {
            "name": "CustomExecutionEnvironment",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "functionName": {
                    "name": "functionName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "availableLibraries": {
                    "name": "availableLibraries",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "ip": {
                    "name": "ip",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "port": {
                    "name": "port",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isGlobal": {
                    "name": "isGlobal",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "CustomExecutionEnvironments",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceCustomExecutionEnvironment",
                        "queryField": "customExecutionEnvironmentByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Site": {
            "name": "Site",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "url": {
                    "name": "url",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "customSitemap": {
                    "name": "customSitemap",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "topics": {
                    "name": "topics",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "SiteStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "lastValidationDate": {
                    "name": "lastValidationDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "lastValidationRequested": {
                    "name": "lastValidationRequested",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "validationToken": {
                    "name": "validationToken",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "allowedPaths": {
                    "name": "allowedPaths",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "siteTree": {
                    "name": "siteTree",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "lastScraped": {
                    "name": "lastScraped",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "skipOwnerValidation": {
                    "name": "skipOwnerValidation",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "useProxy": {
                    "name": "useProxy",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "completion_percentage": {
                    "name": "completion_percentage",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "extractImages": {
                    "name": "extractImages",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "freeRoaming": {
                    "name": "freeRoaming",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "scrapingCycle": {
                    "name": "scrapingCycle",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "imgRetrievalPrompt": {
                    "name": "imgRetrievalPrompt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "scapablePages": {
                    "name": "scapablePages",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "scrapedPagesCount": {
                    "name": "scrapedPagesCount",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "Sites",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceSites",
                        "queryField": "sitesByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "ByValidationToken",
                        "queryField": "siteByValidationToken",
                        "fields": [
                            "validationToken"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "EntityAI": {
            "name": "EntityAI",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "owner": {
                    "name": "owner",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "label": {
                    "name": "label",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "EntityAiType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "emoji": {
                    "name": "emoji",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "parentEntity": {
                    "name": "parentEntity",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "backgroundColor": {
                    "name": "backgroundColor",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "EntityAIS",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceEntities",
                        "queryField": "entitiesByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "TrainingLog": {
            "name": "TrainingLog",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "owner": {
                    "name": "owner",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "TrainingStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "trainingIterations": {
                    "name": "trainingIterations",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "lastActivation": {
                    "name": "lastActivation",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "duration": {
                    "name": "duration",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "trainingMeta": {
                    "name": "trainingMeta",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "trainingConfig": {
                    "name": "trainingConfig",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "TrainingLogType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "TrainingLogs",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "StatusTrainingLogs",
                        "queryField": "trainingLogsByStatus",
                        "fields": [
                            "status"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceTrainingLogs",
                        "queryField": "trainingLogsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "BatchJobLog": {
            "name": "BatchJobLog",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "owner": {
                    "name": "owner",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "BatchJobStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "duration": {
                    "name": "duration",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "batchMeta": {
                    "name": "batchMeta",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "batchConfig": {
                    "name": "batchConfig",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "batchOutput": {
                    "name": "batchOutput",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "BatchLogType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "benchmarkID": {
                    "name": "benchmarkID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "agentID": {
                    "name": "agentID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "agentVersion": {
                    "name": "agentVersion",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "reviewerAgentID": {
                    "name": "reviewerAgentID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "reviewerAgentVersion": {
                    "name": "reviewerAgentVersion",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "BatchJobLogs",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceBatchJobLogs",
                        "queryField": "batchJobLogsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "AppLog": {
            "name": "AppLog",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "owner": {
                    "name": "owner",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "LogType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "filename": {
                    "name": "filename",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "event": {
                    "name": "event",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "LogStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "AppLogs",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceAppLogs",
                        "queryField": "appLogsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "RequestLog": {
            "name": "RequestLog",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "srtKey": {
                    "name": "srtKey",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "RequestType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "RequestStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "words": {
                    "name": "words",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "tokens": {
                    "name": "tokens",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "sentences": {
                    "name": "sentences",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "artifactsNumber": {
                    "name": "artifactsNumber",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "modelType": {
                    "name": "modelType",
                    "isArray": false,
                    "type": {
                        "enum": "ModelType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "outputType": {
                    "name": "outputType",
                    "isArray": false,
                    "type": {
                        "enum": "OutputType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "inputTokens": {
                    "name": "inputTokens",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "outputTokens": {
                    "name": "outputTokens",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "totalTokens": {
                    "name": "totalTokens",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "inputCostUSD": {
                    "name": "inputCostUSD",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "outputCostUSD": {
                    "name": "outputCostUSD",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "totalCostUSD": {
                    "name": "totalCostUSD",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "cachedInputTokens": {
                    "name": "cachedInputTokens",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "cacheHitRate": {
                    "name": "cacheHitRate",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "cacheSavingsUSD": {
                    "name": "cacheSavingsUSD",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "callType": {
                    "name": "callType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "callPurpose": {
                    "name": "callPurpose",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "latencyMs": {
                    "name": "latencyMs",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "agentID": {
                    "name": "agentID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "creationTime": {
                    "name": "creationTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "isFromToothFairy": {
                    "name": "isFromToothFairy",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "userID": {
                    "name": "userID",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "supportHours": {
                    "name": "supportHours",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "chatID": {
                    "name": "chatID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "messageID": {
                    "name": "messageID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "RequestLogs",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "requestsByMonthAndWorkspace",
                        "queryField": "requestsByMonthAndWorkspace",
                        "fields": [
                            "srtKey"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceRequestLogs",
                        "queryField": "requestLogsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "RequestLogsByChat",
                        "queryField": "requestLogsByChat",
                        "fields": [
                            "chatID",
                            "creationTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "RequestLogsByMessage",
                        "queryField": "requestLogsByMessage",
                        "fields": [
                            "messageID",
                            "creationTime"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "OutputStream": {
            "name": "OutputStream",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "content": {
                    "name": "content",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "t_content": {
                    "name": "t_content",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "prompt": {
                    "name": "prompt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "t_prompt": {
                    "name": "t_prompt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "RequestType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "RequestStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "humanFeedback": {
                    "name": "humanFeedback",
                    "isArray": false,
                    "type": {
                        "enum": "HumanFeedback"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "humanFeedbackComment": {
                    "name": "humanFeedbackComment",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "humanFeedbackType": {
                    "name": "humanFeedbackType",
                    "isArray": false,
                    "type": {
                        "enum": "HumanFeedbackType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "humanFeedbackSubType": {
                    "name": "humanFeedbackSubType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "humanFeedbackProvidedBy": {
                    "name": "humanFeedbackProvidedBy",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "adminResolution": {
                    "name": "adminResolution",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "adminChecked": {
                    "name": "adminChecked",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "autoTune": {
                    "name": "autoTune",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "scoring": {
                    "name": "scoring",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "OutputStreams",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceOutputStreams",
                        "queryField": "streamsByWorkspace",
                        "fields": [
                            "workspaceID",
                            "humanFeedback"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Folders": {
            "name": "Folders",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "owner": {
                    "name": "owner",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "emoji": {
                    "name": "emoji",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "FolderStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "allowedTopics": {
                    "name": "allowedTopics",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "parent": {
                    "name": "parent",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "Folders",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceFolders",
                        "queryField": "foldersByWorkspaceID",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "DictionaryItem": {
            "name": "DictionaryItem",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "owner": {
                    "name": "owner",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sourceLanguage": {
                    "name": "sourceLanguage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "targetLanguage": {
                    "name": "targetLanguage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "sourceText": {
                    "name": "sourceText",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "targetText": {
                    "name": "targetText",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "pos": {
                    "name": "pos",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "DictionaryItems",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceDictionaryItems",
                        "queryField": "dictionaryItemsByWorkspaceID",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Chat": {
            "name": "Chat",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "owner": {
                    "name": "owner",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "nonModel": "ChatStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "creationTime": {
                    "name": "creationTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "visibility": {
                    "name": "visibility",
                    "isArray": false,
                    "type": {
                        "enum": "ChatVisibility"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "isAIReplying": {
                    "name": "isAIReplying",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "activeMessageForAI": {
                    "name": "activeMessageForAI",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "messages": {
                    "name": "messages",
                    "isArray": true,
                    "type": {
                        "model": "ChatMessage"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true,
                    "association": {
                        "connectionType": "HAS_MANY",
                        "associatedWith": "chatID"
                    }
                },
                "chatHistory": {
                    "name": "chatHistory",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "topics": {
                    "name": "topics",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "documentId": {
                    "name": "documentId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "primaryRole": {
                    "name": "primaryRole",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "primaryAgent": {
                    "name": "primaryAgent",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "plannerAgent": {
                    "name": "plannerAgent",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "forcePlannerStop": {
                    "name": "forcePlannerStop",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowMultipleRoles": {
                    "name": "allowMultipleRoles",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": true,
                    "attributes": []
                },
                "handedOffToHuman": {
                    "name": "handedOffToHuman",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "roles": {
                    "name": "roles",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "language": {
                    "name": "language",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "summary": {
                    "name": "summary",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "caseId": {
                    "name": "caseId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customerId": {
                    "name": "customerId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "caseInfo": {
                    "name": "caseInfo",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "customerInfo": {
                    "name": "customerInfo",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "projectId": {
                    "name": "projectId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "projectInfo": {
                    "name": "projectInfo",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "genericEntityId": {
                    "name": "genericEntityId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "genericEntityInfo": {
                    "name": "genericEntityInfo",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "userFeedbackOnSteps": {
                    "name": "userFeedbackOnSteps",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "channelSettings": {
                    "name": "channelSettings",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "sourceJobID": {
                    "name": "sourceJobID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "canvasID": {
                    "name": "canvasID",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "canvasOperations": {
                    "name": "canvasOperations",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "canvasLastChangesetID": {
                    "name": "canvasLastChangesetID",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "canvasLastChangesetTimestamp": {
                    "name": "canvasLastChangesetTimestamp",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "externalParticipantId": {
                    "name": "externalParticipantId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "piiDetected": {
                    "name": "piiDetected",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "piiTypes": {
                    "name": "piiTypes",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "piiOccurrences": {
                    "name": "piiOccurrences",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "toxicityDetected": {
                    "name": "toxicityDetected",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "toxicityScore": {
                    "name": "toxicityScore",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "toxicityCategories": {
                    "name": "toxicityCategories",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "customerSatisfactionScore": {
                    "name": "customerSatisfactionScore",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "customerSatisfactionFeedback": {
                    "name": "customerSatisfactionFeedback",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "requestCompleted": {
                    "name": "requestCompleted",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "requestCompletionScore": {
                    "name": "requestCompletionScore",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "escalationRequired": {
                    "name": "escalationRequired",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "escalationReason": {
                    "name": "escalationReason",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qualityScore": {
                    "name": "qualityScore",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qualityNotes": {
                    "name": "qualityNotes",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customAnalytics": {
                    "name": "customAnalytics",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "planMode": {
                    "name": "planMode",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "planFile": {
                    "name": "planFile",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "askBeforeExec": {
                    "name": "askBeforeExec",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "planStatus": {
                    "name": "planStatus",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "Chats",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceChats",
                        "queryField": "chatsByWorkspace",
                        "fields": [
                            "workspaceID",
                            "creationTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "chatByExternalParticipantId",
                        "queryField": "chatByExternalParticipantId",
                        "fields": [
                            "externalParticipantId"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "CustomPrompt": {
            "name": "CustomPrompt",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "scope": {
                    "name": "scope",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "style": {
                    "name": "style",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "domain": {
                    "name": "domain",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "label": {
                    "name": "label",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "promptLength": {
                    "name": "promptLength",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": true,
                    "attributes": []
                },
                "promptPlaceholder": {
                    "name": "promptPlaceholder",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "interpolationString": {
                    "name": "interpolationString",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "availableToAgents": {
                    "name": "availableToAgents",
                    "isArray": true,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "CustomPrompts",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceCustomPrompts",
                        "queryField": "customPromptsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "CronJob": {
            "name": "CronJob",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "forcedPrompt": {
                    "name": "forcedPrompt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "CronJobType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "routineConfig": {
                    "name": "routineConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "RoutineConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "agentID": {
                    "name": "agentID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "customPromptID": {
                    "name": "customPromptID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "schedule": {
                    "name": "schedule",
                    "isArray": false,
                    "type": {
                        "nonModel": "CronSchedule"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "timezone": {
                    "name": "timezone",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "isActive": {
                    "name": "isActive",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": true,
                    "attributes": []
                },
                "lastRunAt": {
                    "name": "lastRunAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "nextRunAt": {
                    "name": "nextRunAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "CronJobStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "executionConfig": {
                    "name": "executionConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "CronExecutionConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "notificationConfig": {
                    "name": "notificationConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "CronNotificationConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "retryConfig": {
                    "name": "retryConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "CronRetryConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "startDate": {
                    "name": "startDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "endDate": {
                    "name": "endDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "CronJobs",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "CronJobsByAgent",
                        "queryField": "cronJobsByAgent",
                        "fields": [
                            "agentID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "CronJobsByPrompt",
                        "queryField": "cronJobsByPrompt",
                        "fields": [
                            "customPromptID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "CronJobsByWorkspace",
                        "queryField": "cronJobsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "CronJobsByNextRun",
                        "queryField": "cronJobsByNextRun",
                        "fields": [
                            "nextRunAt",
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Trigger": {
            "name": "Trigger",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "agentID": {
                    "name": "agentID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "customPromptID": {
                    "name": "customPromptID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "forcedPrompt": {
                    "name": "forcedPrompt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "eventSourceType": {
                    "name": "eventSourceType",
                    "isArray": false,
                    "type": {
                        "enum": "TriggerEventSource"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "eventConfig": {
                    "name": "eventConfig",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "isActive": {
                    "name": "isActive",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": true,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "TriggerStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "lastTriggeredAt": {
                    "name": "lastTriggeredAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "lastEventID": {
                    "name": "lastEventID",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "triggerCount": {
                    "name": "triggerCount",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "executionConfig": {
                    "name": "executionConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "CronExecutionConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "notificationConfig": {
                    "name": "notificationConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "CronNotificationConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "retryConfig": {
                    "name": "retryConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "CronRetryConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "Triggers",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "TriggersByAgent",
                        "queryField": "triggersByAgent",
                        "fields": [
                            "agentID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "TriggersByPrompt",
                        "queryField": "triggersByPrompt",
                        "fields": [
                            "customPromptID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "TriggersByWorkspace",
                        "queryField": "triggersByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "CustomCodeExecutionEnvironment": {
            "name": "CustomCodeExecutionEnvironment",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "functionName": {
                    "name": "functionName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "availableLibraries": {
                    "name": "availableLibraries",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customExecutionInstructions": {
                    "name": "customExecutionInstructions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customExecutionCode": {
                    "name": "customExecutionCode",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customExecutionSecrets": {
                    "name": "customExecutionSecrets",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "staticDocs": {
                    "name": "staticDocs",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "staticArtifacts": {
                    "name": "staticArtifacts",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "allowExternalAPI": {
                    "name": "allowExternalAPI",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hardcodedScript": {
                    "name": "hardcodedScript",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isTemplate": {
                    "name": "isTemplate",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customCodeExecutionEnvironmentVersion": {
                    "name": "customCodeExecutionEnvironmentVersion",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "customCodeExecutionEnvironmentType": {
                    "name": "customCodeExecutionEnvironmentType",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "CustomCodeExecutionEnvironments",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceCustomCodeExecutionEnvironments",
                        "queryField": "customCodeExecutionEnvironmentsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "ChatMessage": {
            "name": "ChatMessage",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "role": {
                    "name": "role",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "chatID": {
                    "name": "chatID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "text": {
                    "name": "text",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "t_text": {
                    "name": "t_text",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "t_text_summary": {
                    "name": "t_text_summary",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "creationTime": {
                    "name": "creationTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "scoring": {
                    "name": "scoring",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "embeddingId": {
                    "name": "embeddingId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "humanFeedback": {
                    "name": "humanFeedback",
                    "isArray": false,
                    "type": {
                        "enum": "HumanFeedback"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "humanFeedbackComment": {
                    "name": "humanFeedbackComment",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "humanFeedbackType": {
                    "name": "humanFeedbackType",
                    "isArray": false,
                    "type": {
                        "enum": "HumanFeedbackType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "humanFeedbackSubType": {
                    "name": "humanFeedbackSubType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "humanFeedbackProvidedBy": {
                    "name": "humanFeedbackProvidedBy",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "adminResolution": {
                    "name": "adminResolution",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "prevMessage": {
                    "name": "prevMessage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "prevMessagePosEq": {
                    "name": "prevMessagePosEq",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "prevMessageNegEq": {
                    "name": "prevMessageNegEq",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "correctContext": {
                    "name": "correctContext",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "correctAnswer": {
                    "name": "correctAnswer",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "adminChecked": {
                    "name": "adminChecked",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "autoTune": {
                    "name": "autoTune",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "userID": {
                    "name": "userID",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "agentID": {
                    "name": "agentID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "humanFeedbackForInstruction": {
                    "name": "humanFeedbackForInstruction",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "images": {
                    "name": "images",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "audios": {
                    "name": "audios",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "videos": {
                    "name": "videos",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "files": {
                    "name": "files",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "imagesText": {
                    "name": "imagesText",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "audiosText": {
                    "name": "audiosText",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "videosText": {
                    "name": "videosText",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "filesText": {
                    "name": "filesText",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isAI": {
                    "name": "isAI",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "messageType": {
                    "name": "messageType",
                    "isArray": false,
                    "type": {
                        "enum": "MessageType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "RequestStatus"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "callbackMetadata": {
                    "name": "callbackMetadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "ChatMessages",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "ChatMessages",
                        "queryField": "messagesByChat",
                        "fields": [
                            "chatID",
                            "creationTime"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "AgentChatMessages",
                        "queryField": "messagesByAgent",
                        "fields": [
                            "agentID",
                            "updatedAt"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceChatMessages",
                        "queryField": "messagesByWorkspace",
                        "fields": [
                            "workspaceID",
                            "humanFeedback"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "CommunicationService": {
            "name": "CommunicationService",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "channel": {
                    "name": "channel",
                    "isArray": false,
                    "type": {
                        "enum": "CommunicationChannel"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "provider": {
                    "name": "provider",
                    "isArray": false,
                    "type": {
                        "enum": "CommunicationProvider"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "senderid": {
                    "name": "senderid",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "fromNumber": {
                    "name": "fromNumber",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "tokenSecret": {
                    "name": "tokenSecret",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "sipTrunkId": {
                    "name": "sipTrunkId",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isActive": {
                    "name": "isActive",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": true,
                    "attributes": []
                },
                "config": {
                    "name": "config",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "CommunicationServices",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceCommunicationServices",
                        "queryField": "CommunicationServicesByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "SubscriptionPricingPlan": {
            "name": "SubscriptionPricingPlan",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "PlanType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "subscriptionStatus": {
                    "name": "subscriptionStatus",
                    "isArray": false,
                    "type": {
                        "enum": "SubscriptionStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "isPredictionOnDemandGlobal": {
                    "name": "isPredictionOnDemandGlobal",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isTrainingOnDemandGlobal": {
                    "name": "isTrainingOnDemandGlobal",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "predictionRequestsGlobal": {
                    "name": "predictionRequestsGlobal",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "batchRequestsGlobal": {
                    "name": "batchRequestsGlobal",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "trainingMinutesGlobal": {
                    "name": "trainingMinutesGlobal",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "baseModelGN": {
                    "name": "baseModelGN",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "baseModelQA": {
                    "name": "baseModelQA",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "baseModelNLP": {
                    "name": "baseModelNLP",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "maxUsers": {
                    "name": "maxUsers",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "maxPowerUsers": {
                    "name": "maxPowerUsers",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "agcEnabled": {
                    "name": "agcEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isDownloadModelEnabled": {
                    "name": "isDownloadModelEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isDownloadDataEnabled": {
                    "name": "isDownloadDataEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isAPIAccessEnabled": {
                    "name": "isAPIAccessEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isBatchJobsEnabled": {
                    "name": "isBatchJobsEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isSentimentReviewerEnabled": {
                    "name": "isSentimentReviewerEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isBusinessAnalystEnabled": {
                    "name": "isBusinessAnalystEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isContentCreatorEnabled": {
                    "name": "isContentCreatorEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isPriorityTrainingEnabled": {
                    "name": "isPriorityTrainingEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isPredictionGPUAccelerationEnabledGlobal": {
                    "name": "isPredictionGPUAccelerationEnabledGlobal",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isPredictionGPUAccelerationEnabledRC": {
                    "name": "isPredictionGPUAccelerationEnabledRC",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isPredictionGPUAccelerationEnabledNLP": {
                    "name": "isPredictionGPUAccelerationEnabledNLP",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "aiMaxConsumption": {
                    "name": "aiMaxConsumption",
                    "isArray": false,
                    "type": {
                        "nonModel": "AiWorkspaceConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "maxMrcDocs": {
                    "name": "maxMrcDocs",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxAgents": {
                    "name": "maxAgents",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxSites": {
                    "name": "maxSites",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxBenchmarks": {
                    "name": "maxBenchmarks",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "predictionRequestsAPI": {
                    "name": "predictionRequestsAPI",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "accuracyModelEnabled": {
                    "name": "accuracyModelEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isTrainingNLPEnabled": {
                    "name": "isTrainingNLPEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isTrainingQAEnabled": {
                    "name": "isTrainingQAEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isTrainingGNEnabled": {
                    "name": "isTrainingGNEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isLongTermMemoryEnabled": {
                    "name": "isLongTermMemoryEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isFunctionsEnabled": {
                    "name": "isFunctionsEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isDBFunctionsEnabled": {
                    "name": "isDBFunctionsEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isHtmlFunctionsEnabled": {
                    "name": "isHtmlFunctionsEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isSitesBindingEnabled": {
                    "name": "isSitesBindingEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isAgentsSecurityEnabled": {
                    "name": "isAgentsSecurityEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isWidgetChatsHistoryEnabled": {
                    "name": "isWidgetChatsHistoryEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "maxRequests30Minutes": {
                    "name": "maxRequests30Minutes",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxRequests24Hours": {
                    "name": "maxRequests24Hours",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "defaultSupportHours": {
                    "name": "defaultSupportHours",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "SubscriptionPricingPlans",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceSubscription",
                        "fields": [
                            "type"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Voucher": {
            "name": "Voucher",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "code": {
                    "name": "code",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "amount": {
                    "name": "amount",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": true,
                    "attributes": []
                },
                "currency": {
                    "name": "currency",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "startDate": {
                    "name": "startDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "endDate": {
                    "name": "endDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "VoucherStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "VoucherType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "Vouchers",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "voucherByCode",
                        "queryField": "voucherByCode",
                        "fields": [
                            "code"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "VoucherRedemption": {
            "name": "VoucherRedemption",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "voucherID": {
                    "name": "voucherID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "userID": {
                    "name": "userID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "redeemedAt": {
                    "name": "redeemedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "appliedAmount": {
                    "name": "appliedAmount",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": true,
                    "attributes": []
                },
                "appliedCurrency": {
                    "name": "appliedCurrency",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "orderID": {
                    "name": "orderID",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "VoucherRedemptions",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "redemptionsByVoucher",
                        "queryField": "redemptionsByVoucher",
                        "fields": [
                            "voucherID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "redemptionsByUser",
                        "queryField": "redemptionsByUser",
                        "fields": [
                            "userID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "redemptionsByWorkspace",
                        "queryField": "redemptionsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "SubscriptionBaseConfig": {
            "name": "SubscriptionBaseConfig",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "PlanType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "planConfig": {
                    "name": "planConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "ConfigMapByPlan"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "SubscriptionBaseConfigs",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceSubscriptionBaseConfig",
                        "fields": [
                            "type"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "GenerationConfig": {
            "name": "GenerationConfig",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "styles": {
                    "name": "styles",
                    "isArray": true,
                    "type": {
                        "enum": "GenerationStyles"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                },
                "domains": {
                    "name": "domains",
                    "isArray": true,
                    "type": {
                        "enum": "GenerationDomains"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                },
                "scopes": {
                    "name": "scopes",
                    "isArray": true,
                    "type": {
                        "enum": "GenerationScopes"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                },
                "prompts": {
                    "name": "prompts",
                    "isArray": true,
                    "type": {
                        "nonModel": "Prompt"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "GenerationConfigs",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "ArenaBattle": {
            "name": "ArenaBattle",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "firstAgent": {
                    "name": "firstAgent",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "secondAgent": {
                    "name": "secondAgent",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "firstAgentChatID": {
                    "name": "firstAgentChatID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "secondAgentChatID": {
                    "name": "secondAgentChatID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "winnerID": {
                    "name": "winnerID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "creationTime": {
                    "name": "creationTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "ArenaBattles",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "ArenaBattlesByWorkspace",
                        "queryField": "ArenaBattlesByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Benchmark": {
            "name": "Benchmark",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "questions": {
                    "name": "questions",
                    "isArray": true,
                    "type": {
                        "nonModel": "BenchmarkItem"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": false
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "creationTime": {
                    "name": "creationTime",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "files": {
                    "name": "files",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                }
            },
            "syncable": true,
            "pluralName": "Benchmarks",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "BenchmarksByWorkspace",
                        "queryField": "BenchmarksByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Project": {
            "name": "Project",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "startDate": {
                    "name": "startDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "endDate": {
                    "name": "endDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "ProjectStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "agentID": {
                    "name": "agentID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "Projects",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Reminder": {
            "name": "Reminder",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "title": {
                    "name": "title",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "projectID": {
                    "name": "projectID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "ReminderStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "priority": {
                    "name": "priority",
                    "isArray": false,
                    "type": {
                        "enum": "Priority"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "dueDate": {
                    "name": "dueDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "completedDate": {
                    "name": "completedDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "recurringPattern": {
                    "name": "recurringPattern",
                    "isArray": false,
                    "type": {
                        "enum": "RecurringPattern"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "assignedTo": {
                    "name": "assignedTo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "Reminders",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceByDueDate",
                        "queryField": "remindersByWorkspaceAndDueDate",
                        "fields": [
                            "workspaceID",
                            "dueDate"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "RemindersByProjectID",
                        "queryField": "remindersByProjectID",
                        "fields": [
                            "projectID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceByStatus",
                        "queryField": "remindersByWorkspaceAndStatus",
                        "fields": [
                            "status",
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "WorkspaceByAssignee",
                        "queryField": "remindersByWorkspaceAndAssignees",
                        "fields": [
                            "assignedTo",
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "ProjectItem": {
            "name": "ProjectItem",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "title": {
                    "name": "title",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "ItemType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "ItemStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "priority": {
                    "name": "priority",
                    "isArray": false,
                    "type": {
                        "enum": "Priority"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "dueDate": {
                    "name": "dueDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "assignee": {
                    "name": "assignee",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "projectID": {
                    "name": "projectID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "ProjectItems",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "ProjectItemsByProjectID",
                        "queryField": "projectItemsByProjectID",
                        "fields": [
                            "projectID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "ProjectItemsByWorkspaceID",
                        "queryField": "projectItemsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Customer": {
            "name": "Customer",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "name": {
                    "name": "name",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "companyName": {
                    "name": "companyName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "email": {
                    "name": "email",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "phone": {
                    "name": "phone",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "CustomerType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "CustomerStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "lifecycle": {
                    "name": "lifecycle",
                    "isArray": false,
                    "type": {
                        "enum": "CustomerLifecycle"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "segment": {
                    "name": "segment",
                    "isArray": false,
                    "type": {
                        "enum": "CustomerSegment"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "pipeline": {
                    "name": "pipeline",
                    "isArray": false,
                    "type": {
                        "enum": "PipelineStage"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "lastContactDate": {
                    "name": "lastContactDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "nextFollowUpDate": {
                    "name": "nextFollowUpDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "assignedTo": {
                    "name": "assignedTo",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "totalRevenue": {
                    "name": "totalRevenue",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "potentialValue": {
                    "name": "potentialValue",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "currency": {
                    "name": "currency",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "acquisitionSource": {
                    "name": "acquisitionSource",
                    "isArray": false,
                    "type": {
                        "enum": "AcquisitionSource"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "relationshipStrength": {
                    "name": "relationshipStrength",
                    "isArray": false,
                    "type": {
                        "enum": "RelationshipStrength"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "notes": {
                    "name": "notes",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "Customers",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "CustomersByWorkspaceID",
                        "queryField": "customersByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "Log": {
            "name": "Log",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": {
                        "enum": "CustomerLogType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "action": {
                    "name": "action",
                    "isArray": false,
                    "type": {
                        "enum": "CustomerLogAction"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "performedBy": {
                    "name": "performedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "performedAt": {
                    "name": "performedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "projectItem": {
                    "name": "projectItem",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "customerItem": {
                    "name": "customerItem",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "Logs",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "LogsByWorkspaceID",
                        "queryField": "logsByWorkspace",
                        "fields": [
                            "workspaceID"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "LogsByProjectItemID",
                        "queryField": "logsByProjectItemID",
                        "fields": [
                            "projectItem"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "LogsByCustomerID",
                        "queryField": "logsByCustomerID",
                        "fields": [
                            "customerItem"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        "EntitySnapshot": {
            "name": "EntitySnapshot",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "workspaceID": {
                    "name": "workspaceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "sortKey": {
                    "name": "sortKey",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "entityType": {
                    "name": "entityType",
                    "isArray": false,
                    "type": {
                        "enum": "EntitySnapshotType"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "entityID": {
                    "name": "entityID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "snapshotVersion": {
                    "name": "snapshotVersion",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": true,
                    "attributes": []
                },
                "snapshotData": {
                    "name": "snapshotData",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": true,
                    "attributes": []
                },
                "entityName": {
                    "name": "entityName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "ttl": {
                    "name": "ttl",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "metadata": {
                    "name": "metadata",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "createdBy": {
                    "name": "createdBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "updatedBy": {
                    "name": "updatedBy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                }
            },
            "syncable": true,
            "pluralName": "EntitySnapshots",
            "attributes": [
                {
                    "type": "aws_lambda",
                    "properties": {}
                },
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "SnapshotsByWorkspace",
                        "queryField": "snapshotsByWorkspace",
                        "fields": [
                            "workspaceID",
                            "sortKey"
                        ]
                    }
                },
                {
                    "type": "key",
                    "properties": {
                        "name": "SnapshotsByEntity",
                        "queryField": "snapshotsByEntity",
                        "fields": [
                            "entityID",
                            "sortKey"
                        ]
                    }
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "custom",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            },
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        }
    },
    "enums": {
        "UserType": {
            "name": "UserType",
            "values": [
                "Root",
                "SuperAdmin",
                "ContentAdmin",
                "BillingAdmin",
                "AIEngineer",
                "User"
            ]
        },
        "AlertTriggerType": {
            "name": "AlertTriggerType",
            "values": [
                "ANALYTICS",
                "SYSTEM",
                "CUSTOM"
            ]
        },
        "AlertSeverity": {
            "name": "AlertSeverity",
            "values": [
                "info",
                "warning",
                "critical"
            ]
        },
        "AlertConditionOperator": {
            "name": "AlertConditionOperator",
            "values": [
                "eq",
                "neq",
                "gt",
                "gte",
                "lt",
                "lte",
                "contains",
                "not_contains"
            ]
        },
        "AuthorisationType": {
            "name": "AuthorisationType",
            "values": [
                "bearer",
                "apikey",
                "oauth",
                "password",
                "env",
                "generic",
                "none",
                "username_and_password",
                "basic"
            ]
        },
        "SearchStrategy": {
            "name": "SearchStrategy",
            "values": [
                "parallel",
                "targeted_first",
                "vector_first"
            ]
        },
        "ReasoningMode": {
            "name": "ReasoningMode",
            "values": [
                "auto",
                "dynamic",
                "always",
                "never"
            ]
        },
        "ReasoningEffort": {
            "name": "ReasoningEffort",
            "values": [
                "none",
                "low",
                "medium",
                "high"
            ]
        },
        "HostingType": {
            "name": "HostingType",
            "values": [
                "azure_openai",
                "aws",
                "local",
                "google",
                "anthropic",
                "together",
                "tf",
                "replicate",
                "azure",
                "openai",
                "groq",
                "ollama"
            ]
        },
        "FunctionRequestType": {
            "name": "FunctionRequestType",
            "values": [
                "get",
                "post",
                "put",
                "delete",
                "patch",
                "custom",
                "graphql_query",
                "graphql_mutation"
            ]
        },
        "RequestType": {
            "name": "RequestType",
            "values": [
                "translator",
                "answerer",
                "parser",
                "tokenizer",
                "embedder",
                "detector",
                "questioner",
                "generator",
                "chatter",
                "planner",
                "analyser",
                "browser",
                "voice",
                "tfcode",
                "tfdesign",
                "proxy",
                "vectorisation",
                "image_extraction",
                "support",
                "code_execution"
            ]
        },
        "OutputType": {
            "name": "OutputType",
            "values": [
                "images",
                "videos",
                "modelling",
                "text",
                "code_interpreter",
                "canvas",
                "internet_search",
                "deep_thinking",
                "browser",
                "audio",
                "voice",
                "rag"
            ]
        },
        "RequestStatus": {
            "name": "RequestStatus",
            "values": [
                "success",
                "failed",
                "timeout",
                "fulfilled",
                "pending",
                "inProgress",
                "cancelled",
                "awaitingUserInput",
                "continued",
                "ingested"
            ]
        },
        "AgentType": {
            "name": "AgentType",
            "values": [
                "Chatbot",
                "BusinessAnalyst",
                "ContentCreator",
                "Default"
            ]
        },
        "ModelType": {
            "name": "ModelType",
            "values": [
                "extraSmall",
                "small",
                "medium",
                "large",
                "extraLarge",
                "ultra",
                "local",
                "custom",
                "external"
            ]
        },
        "SiteStatus": {
            "name": "SiteStatus",
            "values": [
                "noDomain",
                "noAnswer",
                "active",
                "syncing",
                "inactive",
                "invalidToken",
                "failed",
                "pending",
                "inProgress",
                "validationTokenCreationError",
                "readyForValidation",
                "tokenRequested",
                "noSitemap"
            ]
        },
        "FunctionScope": {
            "name": "FunctionScope",
            "values": [
                "customerAuthentication",
                "customer",
                "caseAuthentication",
                "case"
            ]
        },
        "ChatVisibility": {
            "name": "ChatVisibility",
            "values": [
                "public",
                "private",
                "widget",
                "job",
                "incognito"
            ]
        },
        "HumanFeedbackType": {
            "name": "HumanFeedbackType",
            "values": [
                "multilanguage",
                "documentation",
                "reasoning",
                "images",
                "charting",
                "api",
                "code",
                "math",
                "moderation"
            ]
        },
        "MultiLanguageHumanFeedbackSubType": {
            "name": "MultiLanguageHumanFeedbackSubType",
            "values": [
                "translation",
                "languageDetection",
                "languageDetectionAndTranslation"
            ]
        },
        "DocumentationHumanFeedbackSubType": {
            "name": "DocumentationHumanFeedbackSubType",
            "values": [
                "OutdatedDocumentation",
                "MissingDocumentation",
                "IncorrectDocumentation"
            ]
        },
        "ReasoningHumanFeedbackSubType": {
            "name": "ReasoningHumanFeedbackSubType",
            "values": [
                "IncorrectAnswer",
                "OutOfContextAnswer"
            ]
        },
        "ImagesHumanFeedbackSubType": {
            "name": "ImagesHumanFeedbackSubType",
            "values": [
                "IncorrectImage",
                "MissingImage"
            ]
        },
        "ChartingHumanFeedbackSubType": {
            "name": "ChartingHumanFeedbackSubType",
            "values": [
                "IncorrectChart",
                "MissingChart"
            ]
        },
        "ModerationHumanFeedbackSubType": {
            "name": "ModerationHumanFeedbackSubType",
            "values": [
                "IncorrectModeration",
                "MissingModeration"
            ]
        },
        "AgentFunctionChatAction": {
            "name": "AgentFunctionChatAction",
            "values": [
                "suggestion",
                "nextQuestion",
                "humanSupport",
                "redirection",
                "script"
            ]
        },
        "CommunicationChannel": {
            "name": "CommunicationChannel",
            "values": [
                "email",
                "sms",
                "whatsapp",
                "linkedin",
                "sip",
                "telegram"
            ]
        },
        "CommunicationProvider": {
            "name": "CommunicationProvider",
            "values": [
                "sendgrid",
                "ses",
                "mailgun",
                "postmark",
                "mailjet",
                "twilio",
                "whatsapp",
                "sms_magic",
                "sms_magic_sf",
                "linkedin",
                "telegram"
            ]
        },
        "InternetSearchMode": {
            "name": "InternetSearchMode",
            "values": [
                "search",
                "news",
                "images",
                "videos",
                "maps",
                "places",
                "shopping"
            ]
        },
        "VoucherStatus": {
            "name": "VoucherStatus",
            "values": [
                "ACTIVE",
                "INACTIVE"
            ]
        },
        "VoucherType": {
            "name": "VoucherType",
            "values": [
                "CREDIT",
                "FREE_UPGRADE"
            ]
        },
        "ChunkingStrategy": {
            "name": "ChunkingStrategy",
            "values": [
                "keywords",
                "summary"
            ]
        },
        "ExtractionStrategy": {
            "name": "ExtractionStrategy",
            "values": [
                "safe",
                "brute"
            ]
        },
        "GenerationScopes": {
            "name": "GenerationScopes",
            "values": [
                "generation",
                "tweet",
                "post",
                "title",
                "email",
                "paraphrase",
                "paraphraseLiteral",
                "summary",
                "simplify",
                "custom"
            ]
        },
        "GenerationStyles": {
            "name": "GenerationStyles",
            "values": [
                "default",
                "short",
                "long",
                "funny",
                "informal",
                "formal",
                "interview",
                "academic",
                "business",
                "creative",
                "scientific",
                "poetry",
                "news"
            ]
        },
        "ChatMode": {
            "name": "ChatMode",
            "values": [
                "speed",
                "accuracy",
                "custom",
                "retriever",
                "coder",
                "mathematician",
                "chatter",
                "planner",
                "computer",
                "voice"
            ]
        },
        "GenerationMode": {
            "name": "GenerationMode",
            "values": [
                "speed",
                "accuracy",
                "custom"
            ]
        },
        "HumanFeedback": {
            "name": "HumanFeedback",
            "values": [
                "positive",
                "negative",
                "neutral"
            ]
        },
        "MessageType": {
            "name": "MessageType",
            "values": [
                "system",
                "handoff",
                "notification",
                "continuation"
            ]
        },
        "GenerationDomains": {
            "name": "GenerationDomains",
            "values": [
                "editorial",
                "customerService",
                "sales",
                "marketing",
                "hr",
                "finance",
                "legal",
                "medical",
                "science",
                "technology",
                "default"
            ]
        },
        "Department": {
            "name": "Department",
            "values": [
                "HUMAN_RESOURCES",
                "FINANCE_AND_ACCOUNTING",
                "SALES",
                "MARKETING",
                "OPERATIONS",
                "INFORMATION_TECHNOLOGY",
                "CUSTOMER_SERVICE",
                "RESEARCH_AND_DEVELOPMENT",
                "LEGAL_AND_COMPLIANCE",
                "SUPPLY_CHAIN_MANAGEMENT",
                "PROJECT_MANAGEMENT",
                "GENERAL_PURPOSE"
            ]
        },
        "Visibility": {
            "name": "Visibility",
            "values": [
                "private",
                "public",
                "shared"
            ]
        },
        "BaseModelType": {
            "name": "BaseModelType",
            "values": [
                "productivity",
                "sentiment",
                "none"
            ]
        },
        "EntityAiType": {
            "name": "EntityAiType",
            "values": [
                "ner",
                "intent",
                "topic",
                "agentGroup",
                "functionGroup",
                "hookGroup"
            ]
        },
        "FolderStatus": {
            "name": "FolderStatus",
            "values": [
                "active",
                "inactive"
            ]
        },
        "WorkspaceAiType": {
            "name": "WorkspaceAiType",
            "values": [
                "hierarchical",
                "flat"
            ]
        },
        "BatchLogType": {
            "name": "BatchLogType",
            "values": [
                "nlp",
                "rc",
                "gn",
                "bm",
                "abm"
            ]
        },
        "SubscriptionStatus": {
            "name": "SubscriptionStatus",
            "values": [
                "active",
                "inactive"
            ]
        },
        "TrainingStatus": {
            "name": "TrainingStatus",
            "values": [
                "dispatched",
                "inProgress",
                "completed",
                "inError",
                "cancelled",
                "cancellationRequested",
                "training",
                "swapping",
                "swapModelFailed",
                "swapModelRequested",
                "datasetReady",
                "modelReady",
                "fineTuningRequested"
            ]
        },
        "BatchJobStatus": {
            "name": "BatchJobStatus",
            "values": [
                "dispatched",
                "inProgress",
                "completed",
                "inError",
                "cancelled",
                "cancellationRequested"
            ]
        },
        "QaUrlStatus": {
            "name": "QaUrlStatus",
            "values": [
                "ready",
                "notReady",
                "dismissed",
                "unknown",
                "swapping"
            ]
        },
        "PlanType": {
            "name": "PlanType",
            "values": [
                "base",
                "pro",
                "business",
                "enterprise"
            ]
        },
        "BillingProvider": {
            "name": "BillingProvider",
            "values": [
                "STRIPE",
                "XERO",
                "NONE"
            ]
        },
        "LogType": {
            "name": "LogType",
            "values": [
                "import",
                "export",
                "entityDeletion",
                "documentImport"
            ]
        },
        "LogStatus": {
            "name": "LogStatus",
            "values": [
                "dispatched",
                "inProgress",
                "completed",
                "inError"
            ]
        },
        "TrainingLogType": {
            "name": "TrainingLogType",
            "values": [
                "nlpTraining",
                "readComprehensionTraining",
                "generativeTraining",
                "conversationalTraining",
                "grpoTraining",
                "ktoTraining",
                "continuedPretraining"
            ]
        },
        "QaUrlType": {
            "name": "QaUrlType",
            "values": [
                "serverless",
                "provisioned",
                "elastic"
            ]
        },
        "ReminderStatus": {
            "name": "ReminderStatus",
            "values": [
                "PENDING",
                "COMPLETED",
                "CANCELLED",
                "OVERDUE"
            ]
        },
        "ReminderPriority": {
            "name": "ReminderPriority",
            "values": [
                "LOW",
                "MEDIUM",
                "HIGH",
                "URGENT"
            ]
        },
        "RecurringPattern": {
            "name": "RecurringPattern",
            "values": [
                "NONE",
                "DAILY",
                "WEEKLY",
                "MONTHLY",
                "YEARLY"
            ]
        },
        "ProjectStatus": {
            "name": "ProjectStatus",
            "values": [
                "PLANNING",
                "ACTIVE",
                "ON_HOLD",
                "COMPLETED",
                "CANCELLED",
                "ARCHIVED"
            ]
        },
        "ItemType": {
            "name": "ItemType",
            "values": [
                "TASK",
                "MILESTONE",
                "ISSUE",
                "RISK",
                "DECISION",
                "DEPENDENCY",
                "DELIVERABLE"
            ]
        },
        "ItemStatus": {
            "name": "ItemStatus",
            "values": [
                "TODO",
                "IN_PROGRESS",
                "BLOCKED",
                "COMPLETED",
                "ON_HOLD",
                "CANCELLED",
                "PENDING",
                "ACHIEVED",
                "DELAYED",
                "OPEN",
                "RESOLVED",
                "REOPENED",
                "IDENTIFIED",
                "MITIGATED",
                "ACCEPTED",
                "AVOIDED"
            ]
        },
        "Priority": {
            "name": "Priority",
            "values": [
                "CRITICAL",
                "HIGH",
                "MEDIUM",
                "LOW",
                "NONE"
            ]
        },
        "CustomerType": {
            "name": "CustomerType",
            "values": [
                "INDIVIDUAL",
                "COMPANY",
                "GOVERNMENT",
                "NON_PROFIT",
                "RESELLER",
                "PARTNER"
            ]
        },
        "CustomerStatus": {
            "name": "CustomerStatus",
            "values": [
                "ACTIVE",
                "INACTIVE",
                "CHURNED",
                "BLOCKED",
                "PENDING_REVIEW"
            ]
        },
        "CustomerLifecycle": {
            "name": "CustomerLifecycle",
            "values": [
                "LEAD",
                "PROSPECT",
                "QUALIFIED",
                "NEGOTIATING",
                "CUSTOMER",
                "REPEAT_CUSTOMER",
                "ADVOCATE",
                "CHURNED"
            ]
        },
        "CustomerSegment": {
            "name": "CustomerSegment",
            "values": [
                "ENTERPRISE",
                "MID_MARKET",
                "SMB",
                "STARTUP",
                "STRATEGIC",
                "GROWTH"
            ]
        },
        "PipelineStage": {
            "name": "PipelineStage",
            "values": [
                "NEW_CONTACT",
                "DISCOVERY",
                "QUALIFICATION",
                "PROPOSAL",
                "NEGOTIATION",
                "CLOSING",
                "WON",
                "LOST",
                "ON_HOLD"
            ]
        },
        "AcquisitionSource": {
            "name": "AcquisitionSource",
            "values": [
                "REFERRAL",
                "WEBSITE",
                "SOCIAL_MEDIA",
                "EVENT",
                "COLD_OUTREACH",
                "PARTNERSHIP",
                "ADVERTISING",
                "WORD_OF_MOUTH",
                "OTHER"
            ]
        },
        "RelationshipStrength": {
            "name": "RelationshipStrength",
            "values": [
                "CHAMPION",
                "STRONG",
                "GOOD",
                "NEUTRAL",
                "WEAK",
                "AT_RISK"
            ]
        },
        "CustomerLogType": {
            "name": "CustomerLogType",
            "values": [
                "SYSTEM",
                "USER",
                "AUTOMATION",
                "INTEGRATION",
                "API"
            ]
        },
        "CustomerLogAction": {
            "name": "CustomerLogAction",
            "values": [
                "CREATE",
                "UPDATE",
                "DELETE",
                "STATUS_CHANGE",
                "LIFECYCLE_CHANGE",
                "PIPELINE_CHANGE",
                "EMAIL_SENT",
                "EMAIL_RECEIVED",
                "CALL_MADE",
                "CALL_RECEIVED",
                "MEETING_SCHEDULED",
                "MEETING_COMPLETED",
                "NOTE_ADDED",
                "DOCUMENT_UPLOADED",
                "ASSIGNMENT_CHANGED",
                "REVENUE_UPDATED",
                "OPPORTUNITY_CREATED",
                "CUSTOM_ACTION"
            ]
        },
        "CronJobStatus": {
            "name": "CronJobStatus",
            "values": [
                "ACTIVE",
                "PAUSED",
                "DISABLED",
                "RUNNING",
                "SENSING",
                "PLANNING",
                "ACTING",
                "COMPLETED",
                "FAILED",
                "PENDING"
            ]
        },
        "CronJobType": {
            "name": "CronJobType",
            "values": [
                "TASK",
                "ROUTINE"
            ]
        },
        "CronJobFrequency": {
            "name": "CronJobFrequency",
            "values": [
                "MINUTES",
                "HOURLY",
                "DAILY",
                "WEEKLY",
                "MONTHLY",
                "YEARLY",
                "CUSTOM"
            ]
        },
        "TriggerEventSource": {
            "name": "TriggerEventSource",
            "values": [
                "NATIVE",
                "EXTERNAL"
            ]
        },
        "TriggerStatus": {
            "name": "TriggerStatus",
            "values": [
                "ARMED",
                "PAUSED",
                "DISABLED",
                "FIRING",
                "COMPLETED",
                "FAILED",
                "PENDING"
            ]
        },
        "TriggerAcquisitionMode": {
            "name": "TriggerAcquisitionMode",
            "values": [
                "POLLING",
                "WEBHOOK"
            ]
        },
        "TriggerProvider": {
            "name": "TriggerProvider",
            "values": [
                "googleDrive",
                "microsoftGraph",
                "slack",
                "github",
                "notion",
                "dropbox",
                "onedrive",
                "box",
                "salesforce",
                "hubspot",
                "linear",
                "jira",
                "asana",
                "trello",
                "zendesk",
                "servicenow",
                "youtube",
                "gmail",
                "calendar",
                "forms",
                "teams",
                "stripe",
                "generic"
            ]
        },
        "EntitySnapshotType": {
            "name": "EntitySnapshotType",
            "values": [
                "AGENT",
                "AGENT_FUNCTION",
                "CUSTOM_CODE_ENV"
            ]
        }
    },
    "nonModels": {
        "TriggerNativeConfig": {
            "name": "TriggerNativeConfig",
            "fields": {
                "eventType": {
                    "name": "eventType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "eventCategory": {
                    "name": "eventCategory",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "dataFilter": {
                    "name": "dataFilter",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "TriggerExternalConfig": {
            "name": "TriggerExternalConfig",
            "fields": {
                "provider": {
                    "name": "provider",
                    "isArray": false,
                    "type": {
                        "enum": "TriggerProvider"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "providerEvent": {
                    "name": "providerEvent",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "authorisationType": {
                    "name": "authorisationType",
                    "isArray": false,
                    "type": {
                        "enum": "AuthorisationType"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "authorisationID": {
                    "name": "authorisationID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                },
                "acquisitionMode": {
                    "name": "acquisitionMode",
                    "isArray": false,
                    "type": {
                        "enum": "TriggerAcquisitionMode"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "pollConfig": {
                    "name": "pollConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "TriggerPollConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "webhookConfig": {
                    "name": "webhookConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "TriggerWebhookConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "subscriptionID": {
                    "name": "subscriptionID",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "integrationConfig": {
                    "name": "integrationConfig",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "TriggerPollConfig": {
            "name": "TriggerPollConfig",
            "fields": {
                "intervalSeconds": {
                    "name": "intervalSeconds",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "lastCursor": {
                    "name": "lastCursor",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "endpoint": {
                    "name": "endpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "jsonPath": {
                    "name": "jsonPath",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "TriggerWebhookConfig": {
            "name": "TriggerWebhookConfig",
            "fields": {
                "registrationEndpoint": {
                    "name": "registrationEndpoint",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "secret": {
                    "name": "secret",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "ttlSeconds": {
                    "name": "ttlSeconds",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "RoutineConfig": {
            "name": "RoutineConfig",
            "fields": {
                "maxPlannedActions": {
                    "name": "maxPlannedActions",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "ChatStatus": {
            "name": "ChatStatus",
            "fields": {
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "lastUpdated": {
                    "name": "lastUpdated",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "ChannelSettings": {
            "name": "ChannelSettings",
            "fields": {
                "email": {
                    "name": "email",
                    "isArray": false,
                    "type": {
                        "nonModel": "ChannelConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "sms": {
                    "name": "sms",
                    "isArray": false,
                    "type": {
                        "nonModel": "ChannelConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "whatsapp": {
                    "name": "whatsapp",
                    "isArray": false,
                    "type": {
                        "nonModel": "ChannelConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "linkedin": {
                    "name": "linkedin",
                    "isArray": false,
                    "type": {
                        "nonModel": "ChannelConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "sip": {
                    "name": "sip",
                    "isArray": false,
                    "type": {
                        "nonModel": "ChannelConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "telegram": {
                    "name": "telegram",
                    "isArray": false,
                    "type": {
                        "nonModel": "ChannelConfig"
                    },
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "ChannelConfig": {
            "name": "ChannelConfig",
            "fields": {
                "isEnabled": {
                    "name": "isEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "recipient": {
                    "name": "recipient",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "providerID": {
                    "name": "providerID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "CustomGenerationConfig": {
            "name": "CustomGenerationConfig",
            "fields": {
                "styles": {
                    "name": "styles",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                },
                "domains": {
                    "name": "domains",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                },
                "scopes": {
                    "name": "scopes",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                },
                "prompts": {
                    "name": "prompts",
                    "isArray": true,
                    "type": {
                        "nonModel": "Prompt"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": false
                },
                "hasTopicsContext": {
                    "name": "hasTopicsContext",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "topics": {
                    "name": "topics",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "docTopK": {
                    "name": "docTopK",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "topK": {
                    "name": "topK",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "blender": {
                    "name": "blender",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "mode": {
                    "name": "mode",
                    "isArray": false,
                    "type": {
                        "enum": "GenerationMode"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "aiKnowledge": {
                    "name": "aiKnowledge",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "compressor": {
                    "name": "compressor",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "QaRole": {
            "name": "QaRole",
            "fields": {
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "label": {
                    "name": "label",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "description": {
                    "name": "description",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "interpolationString": {
                    "name": "interpolationString",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "emoji": {
                    "name": "emoji",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "color": {
                    "name": "color",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "isDefault": {
                    "name": "isDefault",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasMemory": {
                    "name": "hasMemory",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "hasTopicsContext": {
                    "name": "hasTopicsContext",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "allowedTopics": {
                    "name": "allowedTopics",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "defaultAnswer": {
                    "name": "defaultAnswer",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "stopSequence": {
                    "name": "stopSequence",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "examples": {
                    "name": "examples",
                    "isArray": true,
                    "type": {
                        "nonModel": "QA"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "enhancementPassage": {
                    "name": "enhancementPassage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "inhibitionPassage": {
                    "name": "inhibitionPassage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "pertinencePassage": {
                    "name": "pertinencePassage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "goals": {
                    "name": "goals",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "qaUrl": {
                    "name": "qaUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "topK": {
                    "name": "topK",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "mode": {
                    "name": "mode",
                    "isArray": false,
                    "type": {
                        "enum": "ChatMode"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "charting": {
                    "name": "charting",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "summarisation": {
                    "name": "summarisation",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "compressor": {
                    "name": "compressor",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "docTopK": {
                    "name": "docTopK",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxHistory": {
                    "name": "maxHistory",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxTokens": {
                    "name": "maxTokens",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "topicEnhancer": {
                    "name": "topicEnhancer",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "maxTopics": {
                    "name": "maxTopics",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "blender": {
                    "name": "blender",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "temperature": {
                    "name": "temperature",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "version": {
                    "name": "version",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "subject": {
                    "name": "subject",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "CronSchedule": {
            "name": "CronSchedule",
            "fields": {
                "frequency": {
                    "name": "frequency",
                    "isArray": false,
                    "type": {
                        "enum": "CronJobFrequency"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "interval": {
                    "name": "interval",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "cronExpression": {
                    "name": "cronExpression",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "dayOfWeek": {
                    "name": "dayOfWeek",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "dayOfMonth": {
                    "name": "dayOfMonth",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "hour": {
                    "name": "hour",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "minute": {
                    "name": "minute",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "startDate": {
                    "name": "startDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                },
                "endDate": {
                    "name": "endDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "CronExecutionConfig": {
            "name": "CronExecutionConfig",
            "fields": {
                "timeout": {
                    "name": "timeout",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxDuration": {
                    "name": "maxDuration",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "priority": {
                    "name": "priority",
                    "isArray": false,
                    "type": {
                        "enum": "Priority"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "inputParameters": {
                    "name": "inputParameters",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                },
                "outputFormat": {
                    "name": "outputFormat",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "webhookUrl": {
                    "name": "webhookUrl",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "webhookHeaders": {
                    "name": "webhookHeaders",
                    "isArray": false,
                    "type": "AWSJSON",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "CronNotificationConfig": {
            "name": "CronNotificationConfig",
            "fields": {
                "onSuccess": {
                    "name": "onSuccess",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "onFailure": {
                    "name": "onFailure",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "onStart": {
                    "name": "onStart",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "emailRecipients": {
                    "name": "emailRecipients",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "communicationServiceID": {
                    "name": "communicationServiceID",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "CronRetryConfig": {
            "name": "CronRetryConfig",
            "fields": {
                "maxRetries": {
                    "name": "maxRetries",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "retryInterval": {
                    "name": "retryInterval",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "backoffMultiplier": {
                    "name": "backoffMultiplier",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "maxRetryInterval": {
                    "name": "maxRetryInterval",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "CustomQaConfig": {
            "name": "CustomQaConfig",
            "fields": {
                "roles": {
                    "name": "roles",
                    "isArray": true,
                    "type": {
                        "nonModel": "QaRole"
                    },
                    "isRequired": true,
                    "attributes": [],
                    "isArrayNullable": true
                }
            }
        },
        "AiWorkspaceConsumption": {
            "name": "AiWorkspaceConsumption",
            "fields": {
                "generator": {
                    "name": "generator",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "questioner": {
                    "name": "questioner",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "translator": {
                    "name": "translator",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "answerer": {
                    "name": "answerer",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "parser": {
                    "name": "parser",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "tokenizer": {
                    "name": "tokenizer",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "embedder": {
                    "name": "embedder",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "detector": {
                    "name": "detector",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "chatter": {
                    "name": "chatter",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "planner": {
                    "name": "planner",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "analyser": {
                    "name": "analyser",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "code_execution": {
                    "name": "code_execution",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "browser": {
                    "name": "browser",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "voice": {
                    "name": "voice",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "tfcode": {
                    "name": "tfcode",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "tfdesign": {
                    "name": "tfdesign",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "proxy": {
                    "name": "proxy",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "vectorisation": {
                    "name": "vectorisation",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "image_extraction": {
                    "name": "image_extraction",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "support": {
                    "name": "support",
                    "isArray": false,
                    "type": {
                        "nonModel": "ApiMethodConsumption"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "lastUpdate": {
                    "name": "lastUpdate",
                    "isArray": false,
                    "type": "AWSTimestamp",
                    "isRequired": false,
                    "attributes": []
                },
                "requestsLast30Minutes": {
                    "name": "requestsLast30Minutes",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "requestsLast24Hours": {
                    "name": "requestsLast24Hours",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "totalUoI": {
                    "name": "totalUoI",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "totalCostUSD": {
                    "name": "totalCostUSD",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "familyBudgetUoI": {
                    "name": "familyBudgetUoI",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "familyMaxUsers": {
                    "name": "familyMaxUsers",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "childrenCount": {
                    "name": "childrenCount",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "cachedInputTokens": {
                    "name": "cachedInputTokens",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "cacheSavingsUSD": {
                    "name": "cacheSavingsUSD",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "ApiMethodConsumption": {
            "name": "ApiMethodConsumption",
            "fields": {
                "requests": {
                    "name": "requests",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "words": {
                    "name": "words",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "tokens": {
                    "name": "tokens",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "sentences": {
                    "name": "sentences",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "apiRequests": {
                    "name": "apiRequests",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "uoi": {
                    "name": "uoi",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "costUSD": {
                    "name": "costUSD",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "inputTokens": {
                    "name": "inputTokens",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "cachedInputTokens": {
                    "name": "cachedInputTokens",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "cacheSavingsUSD": {
                    "name": "cacheSavingsUSD",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "Prompt": {
            "name": "Prompt",
            "fields": {
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "label": {
                    "name": "label",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "promptLength": {
                    "name": "promptLength",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": true,
                    "attributes": []
                },
                "promptPlaceholder": {
                    "name": "promptPlaceholder",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "interpolationString": {
                    "name": "interpolationString",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                }
            }
        },
        "BenchmarkItem": {
            "name": "BenchmarkItem",
            "fields": {
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "question": {
                    "name": "question",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "answer": {
                    "name": "answer",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "reasoning": {
                    "name": "reasoning",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "context": {
                    "name": "context",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "images": {
                    "name": "images",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "files": {
                    "name": "files",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                }
            }
        },
        "ConfigMapByPlan": {
            "name": "ConfigMapByPlan",
            "fields": {
                "domain": {
                    "name": "domain",
                    "isArray": false,
                    "type": {
                        "enum": "GenerationDomains"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "parsingConfig": {
                    "name": "parsingConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "ParsingConfig"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "notificationConfig": {
                    "name": "notificationConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "NotificationConfig"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "trainingConfig": {
                    "name": "trainingConfig",
                    "isArray": false,
                    "type": {
                        "nonModel": "TrainingConfig"
                    },
                    "isRequired": true,
                    "attributes": []
                }
            }
        },
        "UserWorkspace": {
            "name": "UserWorkspace",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "username": {
                    "name": "username",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "user_email": {
                    "name": "user_email",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "TrainingConfig": {
            "name": "TrainingConfig",
            "fields": {
                "trainingIterations": {
                    "name": "trainingIterations",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "trainingIterationsNLP": {
                    "name": "trainingIterationsNLP",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "trainingIterationsRC": {
                    "name": "trainingIterationsRC",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "trainingEpochsNLP": {
                    "name": "trainingEpochsNLP",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "trainingEpochsRC": {
                    "name": "trainingEpochsRC",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "trainingEpochsGN": {
                    "name": "trainingEpochsGN",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "maxStepsNLP": {
                    "name": "maxStepsNLP",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "patienceNLP": {
                    "name": "patienceNLP",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "learningRateNLP": {
                    "name": "learningRateNLP",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "learningRateRC": {
                    "name": "learningRateRC",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "testSizeNLP": {
                    "name": "testSizeNLP",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "testSizeRC": {
                    "name": "testSizeRC",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "batchSizeNLP": {
                    "name": "batchSizeNLP",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "batchSizeRC": {
                    "name": "batchSizeRC",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "datasetTestSizeThresholdNLP": {
                    "name": "datasetTestSizeThresholdNLP",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "datasetTestSizeThresholdRC": {
                    "name": "datasetTestSizeThresholdRC",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "learningRateGN": {
                    "name": "learningRateGN",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "testSizeGN": {
                    "name": "testSizeGN",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "batchSizeGN": {
                    "name": "batchSizeGN",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "datasetTestSizeThresholdGN": {
                    "name": "datasetTestSizeThresholdGN",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "enableManagedSpotTraining": {
                    "name": "enableManagedSpotTraining",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "maxRuntimeWaitTime": {
                    "name": "maxRuntimeWaitTime",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "maxRuntime": {
                    "name": "maxRuntime",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "includeReadComprehensionDataInTraining": {
                    "name": "includeReadComprehensionDataInTraining",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "generateDockerImageForRCengine": {
                    "name": "generateDockerImageForRCengine",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "generateDockerImageForNLPengine": {
                    "name": "generateDockerImageForNLPengine",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "generateDockerImageForGNengine": {
                    "name": "generateDockerImageForGNengine",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "emailsListForTrainingConfirmation": {
                    "name": "emailsListForTrainingConfirmation",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "maxQueueWaitTime": {
                    "name": "maxQueueWaitTime",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "ParsingConfig": {
            "name": "ParsingConfig",
            "fields": {
                "questionsLimit": {
                    "name": "questionsLimit",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "answerAsNER": {
                    "name": "answerAsNER",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "answerByParagraph": {
                    "name": "answerByParagraph",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "uniqueAnswer": {
                    "name": "uniqueAnswer",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isSentenceSplitEnabled": {
                    "name": "isSentenceSplitEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "isImplicitSelfEnabled": {
                    "name": "isImplicitSelfEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "temperature": {
                    "name": "temperature",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "maxTokens": {
                    "name": "maxTokens",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "topP": {
                    "name": "topP",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "topK": {
                    "name": "topK",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "qaDocTopK": {
                    "name": "qaDocTopK",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "frequencyPenalty": {
                    "name": "frequencyPenalty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "presencePenalty": {
                    "name": "presencePenalty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "qaTopP": {
                    "name": "qaTopP",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "qaTopK": {
                    "name": "qaTopK",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "qaMaxTokens": {
                    "name": "qaMaxTokens",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "qaTemperature": {
                    "name": "qaTemperature",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "qaFrequencyPenalty": {
                    "name": "qaFrequencyPenalty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "qaPresencePenalty": {
                    "name": "qaPresencePenalty",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "qaReplyOutsidePassage": {
                    "name": "qaReplyOutsidePassage",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "qaAiKnowledge": {
                    "name": "qaAiKnowledge",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "qaInhibitionPassage": {
                    "name": "qaInhibitionPassage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qaEnhancementPassage": {
                    "name": "qaEnhancementPassage",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qaRole": {
                    "name": "qaRole",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qaDefaultAnswer": {
                    "name": "qaDefaultAnswer",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qaStopSequence": {
                    "name": "qaStopSequence",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "stopSequence": {
                    "name": "stopSequence",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "stopPrompt": {
                    "name": "stopPrompt",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "qaExamples": {
                    "name": "qaExamples",
                    "isArray": true,
                    "type": {
                        "nonModel": "QA"
                    },
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "qaBlender": {
                    "name": "qaBlender",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "agcEnabled": {
                    "name": "agcEnabled",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "NotificationConfig": {
            "name": "NotificationConfig",
            "fields": {
                "emailsList": {
                    "name": "emailsList",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "emailOnTrainingCompleted": {
                    "name": "emailOnTrainingCompleted",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "emailOnBatchCompleted": {
                    "name": "emailOnBatchCompleted",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "emailOnBatchFailed": {
                    "name": "emailOnBatchFailed",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "emailOnBatchStart": {
                    "name": "emailOnBatchStart",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "emailOnTrainingFailed": {
                    "name": "emailOnTrainingFailed",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "emailOnTrainingStart": {
                    "name": "emailOnTrainingStart",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "notifyAllUsersInWorkspace": {
                    "name": "notifyAllUsersInWorkspace",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "notifyOnThreasholdConsumption": {
                    "name": "notifyOnThreasholdConsumption",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "notificationThresholdConsumption": {
                    "name": "notificationThresholdConsumption",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "EmbeddingConfig": {
            "name": "EmbeddingConfig",
            "fields": {
                "maxChunkWords": {
                    "name": "maxChunkWords",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "maxOverlapSentences": {
                    "name": "maxOverlapSentences",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "chunkingStrategy": {
                    "name": "chunkingStrategy",
                    "isArray": false,
                    "type": {
                        "enum": "ChunkingStrategy"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "imageExtractionStrategy": {
                    "name": "imageExtractionStrategy",
                    "isArray": false,
                    "type": {
                        "enum": "ExtractionStrategy"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "minImageWidth": {
                    "name": "minImageWidth",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "minImageHeight": {
                    "name": "minImageHeight",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "aspectRatioMin": {
                    "name": "aspectRatioMin",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "aspectRatioMax": {
                    "name": "aspectRatioMax",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "ModelDocumentFilterInput": {
            "name": "ModelDocumentFilterInput",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": false,
                    "attributes": []
                },
                "type": {
                    "name": "type",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "istrained": {
                    "name": "istrained",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "workspaceid": {
                    "name": "workspaceid",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                }
            }
        },
        "QA": {
            "name": "QA",
            "fields": {
                "question": {
                    "name": "question",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "answer": {
                    "name": "answer",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                }
            }
        },
        "Document": {
            "name": "Document",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "embedding_status": {
                    "name": "embedding_status",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "completion_percentage": {
                    "name": "completion_percentage",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                }
            }
        },
        "MinimalChatUpdate": {
            "name": "MinimalChatUpdate",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "isAIReplying": {
                    "name": "isAIReplying",
                    "isArray": false,
                    "type": "Boolean",
                    "isRequired": false,
                    "attributes": []
                },
                "activeMessageForAI": {
                    "name": "activeMessageForAI",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": false,
                    "attributes": []
                }
            }
        }
    },
    "codegenVersion": "3.4.3",
    "version": "8ade0d8def700ff3f6b4026995cdb66b"
};